import { oruntuBul, marstonEksenleri, uyarlamaEnerjisi, bicimGucu } from "./discLiterature.js";
import { algiOkumalari } from "./discAlgi.js";

export const DISC_LABELS = ["D", "I", "S", "C"];

export const SCORE_BANDS = [
  { key: "veryHigh", min: 75, max: 100, tr: "Çok yüksek", en: "Very high" },
  { key: "high", min: 60, max: 74, tr: "Yüksek", en: "High" },
  { key: "medium", min: 50, max: 59, tr: "Orta", en: "Moderate" },
  { key: "lowerMiddle", min: 40, max: 49, tr: "Alt orta", en: "Lower-moderate" },
  { key: "low", min: 20, max: 39, tr: "Düşük", en: "Low" },
  { key: "veryLow", min: 0, max: 19, tr: "Çok düşük", en: "Very low" }
];

// KARAR 2026-08-21 (Ajlan, seçenek 3 — "ikisi birlikte"):
//   BAŞLIKTA klasik DISC boyut adı   → KLASIK_BOYUT_ADI
//   ANLATIDA Someren stil adı        → STYLE_NAMES
// Klasik adlar `discBrand.js` → HARF_ICERIK.tam ile BİREBİR aynıdır; orada
// değişirse burası da değişmeli. Referans PDF'i klasik adları kullanıyor,
// marka dilimiz stil adlarını — bu ayrım ikisini de korur.
const KLASIK_BOYUT_ADI = {
  tr: {
    D: "Kararlılık / Dominance",
    I: "Etki / Influence",
    S: "İstikrar / Steadiness",
    C: "Titizlik / Conscientiousness"
  },
  en: {
    D: "Dominance",
    I: "Influence",
    S: "Steadiness",
    C: "Conscientiousness"
  }
};

const STYLE_NAMES = {
  tr: {
    D: "Direct / Direk",
    I: "Influencer / İfadeci / İz Bırakan",
    S: "Steadfast / Sadık / Sabırlı",
    C: "Cautious / Ciddi"
  },
  en: {
    D: "Direct",
    I: "Influencer / Expressive",
    S: "Steadfast / Patient",
    C: "Cautious / Serious"
  }
};

const STYLE_CONTENT = {
  tr: {
    D: {
      core: "sonuca giden yolu kısaltma, yön verme ve karar alanı açma",
      work: "Hedefi netleştirip seçenekleri hızla daraltır; belirsizlik uzadığında kontrolü ele alma eğilimi gösterir.",
      decision: "Kararda hız, etki ve sonuç ölçütlerini öne alır.",
      contribution: "Karar alma, sınır koyma, sahiplenme ve sonuç üretme",
      excess: "Çok görünür olduğunda hız, katılımın ve nüansın önüne geçebilir.",
      underuse: "Daha az görünür olduğunda zor konuları açmak, hızlı karar vermek ve net sınır koymak bilinçli çaba isteyebilir."
    },
    I: {
      core: "insanları harekete geçirme, görünür enerji üretme ve etki alanı kurma",
      work: "Fikirleri ilişki ve anlatı üzerinden görünür kılar; etkileşim yükseldiğinde enerjisi de yükselir.",
      decision: "Kararda kabul, heyecan, ilişki etkisi ve olasılıkları öne alır.",
      contribution: "İkna, bağ kurma, katılım yaratma ve fikirleri görünür kılma",
      excess: "Çok görünür olduğunda iyimserlik, detay ve takip disiplinini gölgeleyebilir.",
      underuse: "Daha az görünür olduğunda fikirleri tanıtmak, ilişki üzerinden etki kurmak ve görünür olmak bilinçli çaba isteyebilir."
    },
    S: {
      core: "güveni koruma, ritmi sürdürülebilir kılma ve insanlar arasında süreklilik sağlama",
      work: "İstikrar, dinleme ve destek üzerinden ilerler; ani değişimlerde önce güvenli zemini arar.",
      decision: "Kararda ekip etkisi, uygulanabilir tempo ve sürekliliği öne alır.",
      contribution: "Sabır, güven, dinleme, destek ve uygulamada süreklilik",
      excess: "Çok görünür olduğunda uyumu koruma isteği zor kararları veya açık itirazı geciktirebilir.",
      underuse: "Daha az görünür olduğunda sabır, düzenli tempo ve uzun soluklu takip bilinçli yapı isteyebilir."
    },
    C: {
      core: "doğruluğu artırma, riski görme ve işi sağlam bir standarda bağlama",
      work: "Karar öncesi veri, ölçüt ve tutarlılık arar; kalite çıtasını görünür kılar.",
      decision: "Kararda kanıt, kalite, risk ve yöntem tutarlılığını öne alır.",
      contribution: "Analiz, doğruluk, kalite standardı ve risk kontrolü",
      excess: "Çok görünür olduğunda kanıt arayışı hızı, denemeyi ve esnekliği sınırlayabilir.",
      underuse: "Daha az görünür olduğunda detay, ölçüm, belge ve süreç takibi bilinçli sistemle desteklenmelidir."
    }
  },
  en: {
    D: {
      core: "shortening the route to results, giving direction and creating decision space",
      work: "Clarifies the target and narrows options quickly; prolonged uncertainty can trigger a stronger drive to take charge.",
      decision: "Prioritises speed, impact and outcomes in decisions.",
      contribution: "Decision-making, boundaries, ownership and results",
      excess: "At very high visibility, speed can overtake participation and nuance.",
      underuse: "At lower visibility, raising difficult topics, deciding quickly and setting firm boundaries may require deliberate effort."
    },
    I: {
      core: "mobilising people, creating visible energy and building influence",
      work: "Makes ideas visible through relationships and narrative; energy tends to rise with interaction.",
      decision: "Prioritises buy-in, enthusiasm, relationship impact and possibility.",
      contribution: "Persuasion, connection, participation and visibility",
      excess: "At very high visibility, optimism can overshadow detail and follow-through.",
      underuse: "At lower visibility, promoting ideas, influencing through relationships and becoming visible may require deliberate effort."
    },
    S: {
      core: "protecting trust, sustaining pace and creating continuity between people",
      work: "Moves through stability, listening and support; sudden change creates a need for secure ground first.",
      decision: "Prioritises team impact, sustainable pace and continuity.",
      contribution: "Patience, trust, listening, support and continuity",
      excess: "At very high visibility, preserving harmony can delay difficult decisions or open disagreement.",
      underuse: "At lower visibility, patience, steady pace and long-term follow-through may need deliberate structure."
    },
    C: {
      core: "improving accuracy, identifying risk and anchoring work to a sound standard",
      work: "Looks for evidence, criteria and consistency before deciding; makes quality expectations visible.",
      decision: "Prioritises evidence, quality, risk and methodological consistency.",
      contribution: "Analysis, accuracy, quality standards and risk control",
      excess: "At very high visibility, the search for evidence can constrain speed, experimentation and flexibility.",
      underuse: "At lower visibility, detail, measurement, documentation and process follow-through need deliberate systems."
    }
  }
};

const STYLE_SCENARIOS = {
  tr: {
    D: {
      portrait: "Yönü hızla netleştiren, engelleri azaltan ve işi sonuç noktasına taşıyan bir etki yaratır.",
      meeting: "Toplantıda amacı, kararı ve sorumluyu erkenden netleştirmek ister; uzayan keşif bölümü sabrını azaltabilir.",
      conflict: "Anlaşmazlığı doğrudan masaya getirme ve pozisyonunu açık savunma eğilimindedir; tonun etkisini sonucun gerisinde bırakmaması gerekir.",
      pressure: "Baskı yükseldiğinde kontrolü artırabilir, seçenekleri hızla daraltabilir ve daha buyurgan duyulabilir.",
      change: "Değişimin gerekçesinden çok hedefini, yetki alanını ve hızla kaldırılacak engelleri görmek ister.",
      feedback: "Kısa, somut ve sonuca bağlanan geri bildirimi daha kolay kullanır; uzun dolaylı girişler ana mesajı zayıflatabilir.",
      manager: "Net sonuç alanı ve karar yetkisi verin; ara adımları değil kritik sınırları ve teslim ölçütünü yönetin.",
      delegation: "İşi değil sonucu devredin; yetki sınırı, son tarih ve vazgeçilmez kalite ölçütünü baştan belirleyin.",
      experiment: "Önemli bir kararı kapatmadan önce iki karşı görüş isteyin; duyduğunuz bir noktaya göre kararda neyi değiştirdiğinizi kaydedin."
    },
    I: {
      portrait: "Fikre enerji kazandıran, insanları konuşmaya dahil eden ve görünür bir etki alanı oluşturan bir katkı sunar.",
      meeting: "Toplantıda etkileşim, fikir alışverişi ve görünür katılım arar; konuşmanın enerjisini yükseltirken kapanış ayrıntılarını kaçırabilir.",
      conflict: "İlişkiyi korumak için gerilimi yumuşatabilir veya konuyu ikna yoluyla çözmeye çalışabilir; açık anlaşmazlığı net bir karara bağlamak önemlidir.",
      pressure: "Baskı yükseldiğinde daha çok konuşabilir, hızlı iyimserlik üretebilir ve teyit edilmemiş olasılıkları gerçekleşmiş gibi aktarabilir.",
      change: "Değişimi hikâye, fırsat ve insanları harekete geçirecek görünür bir anlam üzerinden sahiplenir.",
      feedback: "Diyalog, örnek ve görünür takdir içeren geri bildirimi daha kolay duyar; mesaj yine de somut davranış ve takip adımıyla kapanmalıdır.",
      manager: "Fikrini görünür kılabileceği alan açın; sözlü enerjiyi yazılı sorumlu, tarih ve başarı ölçütüyle tamamlayın.",
      delegation: "İnsan etkisini ve anlatılacak amacı paylaşın; ardından teslimi, sorumluyu ve kontrol noktasını yazılı netleştirin.",
      experiment: "Bir hafta boyunca verdiğiniz her sözlü taahhüdü sorumlu, tarih ve ölçütle yazılı kapatın; tamamlanma oranını izleyin."
    },
    S: {
      portrait: "Güveni, dinlemeyi ve sürdürülebilir ritmi koruyarak insanların birlikte ilerlemesini kolaylaştırır.",
      meeting: "Toplantıda herkesi dinleyip uygulanabilir bir tempo kurar; sessizlik veya uyum isteği gerçek itirazını görünmez bırakabilir.",
      conflict: "İlişkiyi ve istikrarı korumak için gerilimi erteleme eğilimi gösterebilir; görüşünü erken ve sakin biçimde söylemesi gerekir.",
      pressure: "Baskı yükseldiğinde içine çekilebilir, mevcut düzene daha sıkı tutunabilir ve yardım ihtiyacını geç ifade edebilir.",
      change: "Değişimin insan etkisini, geçiş adımlarını ve desteğin sürekliliğini görürse daha güvenli ilerler.",
      feedback: "Sakin, özel ve güveni koruyan geri bildirimi daha kolay işler; düşünme süresi ve net bir sonraki adım faydalıdır.",
      manager: "Öngörülebilir öncelik ve geçiş süresi sağlayın; sessizliği onay saymadan gerçek görüşünü özellikle sorun.",
      delegation: "Beklentiyi, ritmi ve destek noktalarını anlatın; ani öncelik değişikliklerini gerekçesiyle birlikte erkenden paylaşın.",
      experiment: "Bir toplantının ilk üçte birlik bölümünde en az bir gerçek itirazınızı veya farklı görüşünüzü sakin ve açık biçimde söyleyin."
    },
    C: {
      portrait: "Belirsizliği ölçüte dönüştüren, riski görünür kılan ve işi savunulabilir bir kalite standardına bağlayan katkı sunar.",
      meeting: "Toplantıda amaç, veri, tanım ve karar ölçütü arar; çerçeve belirsizse ayrıntıya dönerek ilerlemeyi yavaşlatabilir.",
      conflict: "Anlaşmazlığı kanıt, tutarlılık ve yöntem üzerinden ele alır; karşı tarafın niyetini yalnız mantık hatası olarak okumaması gerekir.",
      pressure: "Baskı yükseldiğinde daha fazla veri isteyebilir, hata ihtimaline odaklanabilir ve karar eşiğini gereğinden fazla yükseltebilir.",
      change: "Değişimin mantığını, riskini, standardını ve uygulanma yöntemini görürse güvenle katkı verir.",
      feedback: "Hazırlıklı, kanıta dayalı ve tutarlı geri bildirimi ciddiye alır; genellemeler ve çelişkili beklentiler direnci artırabilir.",
      manager: "Kalite ölçütünü ve karar eşiğini baştan açıklayın; analiz için alan verirken karar tarihini de görünür tutun.",
      delegation: "Beklenen standardı, veri kaynağını ve kabul kriterini paylaşın; yöntemin her adımını gereksiz yere tarif etmeyin.",
      experiment: "Bir kararda yeterli kanıt eşiğini ve son karar saatini önceden yazın; yeni veri gelmedikçe kararı yeniden açmayın."
    }
  },
  en: {
    D: {
      portrait: "Creates impact by clarifying direction, removing obstacles and moving work toward a result.",
      meeting: "Wants the purpose, decision and owner clarified early; extended exploration can reduce patience.",
      conflict: "Raises disagreement directly and defends a position clearly; tone should not become secondary to the result.",
      pressure: "Under pressure may increase control, narrow options quickly and sound more commanding.",
      change: "Looks first for the target, authority and obstacles to remove rather than a long rationale.",
      feedback: "Uses concise, specific, outcome-linked feedback best.",
      manager: "Give a clear result area and decision authority; manage critical boundaries and delivery criteria.",
      delegation: "Delegate the outcome, with authority limits, date and non-negotiable quality criteria.",
      experiment: "Before closing an important decision, request two dissenting views and record what changed."
    },
    I: {
      portrait: "Adds energy to ideas, draws people into the conversation and builds visible influence.",
      meeting: "Looks for interaction and visible participation; can miss closure details while lifting the room's energy.",
      conflict: "May soften tension or persuade around it; disagreement still needs an explicit resolution.",
      pressure: "Under pressure may talk more, become quickly optimistic and present untested possibilities as settled.",
      change: "Engages through story, opportunity and visible meaning for people.",
      feedback: "Hears dialogue, examples and visible recognition well; close with observable behaviour and follow-up.",
      manager: "Create room for visible contribution, then anchor verbal energy to an owner, date and measure.",
      delegation: "Share the human purpose, then clarify delivery, ownership and checkpoints in writing.",
      experiment: "For one week, close every verbal commitment with a written owner, date and measure."
    },
    S: {
      portrait: "Protects trust, listening and sustainable rhythm so people can move together.",
      meeting: "Listens and builds a workable pace; harmony can leave genuine objections invisible.",
      conflict: "May postpone tension to protect stability; state the real view early and calmly.",
      pressure: "Under pressure may withdraw, hold tighter to routine and express support needs late.",
      change: "Moves with confidence when the human impact, transition steps and ongoing support are visible.",
      feedback: "Processes calm, private feedback well, with reflection time and a clear next step.",
      manager: "Provide predictable priorities and transition time; ask for the real view rather than treating silence as agreement.",
      delegation: "Explain expectation, rhythm and support points; signal priority changes early.",
      experiment: "State one genuine disagreement calmly within the first third of a meeting."
    },
    C: {
      portrait: "Turns ambiguity into criteria, makes risk visible and anchors work to a defensible standard.",
      meeting: "Looks for purpose, evidence, definitions and decision criteria; ambiguity can slow progress through detail.",
      conflict: "Uses evidence and consistency; avoid reading the other person's intent only as a logic problem.",
      pressure: "Under pressure may request more evidence, focus on error and raise the decision threshold too far.",
      change: "Contributes confidently when logic, risk, standard and method are clear.",
      feedback: "Takes prepared, evidence-based and consistent feedback seriously.",
      manager: "Define quality and the decision threshold; allow analysis while keeping the decision date visible.",
      delegation: "Share standards, data sources and acceptance criteria without prescribing every step.",
      experiment: "Set the sufficient-evidence threshold and decision time in advance; do not reopen without new data."
    }
  }
};

const PROFILE_TITLES = {
  tr: {
    D: "Hız ve Sonuçla Yön Veren",
    I: "İlişki ve Etkiyle Harekete Geçiren",
    S: "Güven ve Süreklilik Kuran",
    C: "Kanıt ve Kaliteyle Güvence Sağlayan"
  },
  en: {
    D: "Directing Through Pace and Results",
    I: "Mobilising Through Connection and Influence",
    S: "Building Trust and Continuity",
    C: "Securing Quality Through Evidence"
  }
};

const PAIR_NARRATIVES = {
  tr: {
    DI: "Direk taraf yönü ve hızı kurarken İfadeci taraf insanları fikrin etrafında toplar. Sonuç odaklı ve ikna gücü yüksek bir etki yaratır; vaat ile takip arasındaki denge önemlidir.",
    ID: "İfadeci taraf önce bağ ve enerji kurar, Direk taraf bu enerjiyi karara çevirir. Görünür, girişken ve harekete geçirici bir örüntüdür; dinleme alanını aceleyle kapatmamak gerekir.",
    DS: "Direk taraf yönü belirler, Sadık/Sabırlı taraf uygulamayı istikrara taşır. Hız ile güvence arasında yapıcı bir gerilim vardır; değişimin temposu açık konuşulmalıdır.",
    SD: "Sadık/Sabırlı taraf güvenli zemini kurar, Direk taraf gerektiğinde sınır ve karar getirir. Kararlılık gecikmeden, karar da ani sertliğe dönüşmeden kullanılmalıdır.",
    DC: "Direk taraf kararı ilerletir, Ciddi taraf kararın kanıtını ve standardını sınar. Hız ile kaliteyi birlikte taşıyabilir; tartışmanın güç savaşına dönüşmemesi önemlidir.",
    CD: "Ciddi taraf çerçeveyi veriyle kurar, Direk taraf kapanışı ve eylemi getirir. Güçlü bir sorun çözme bileşimidir; analiz tamamlanmadan baskı, karar sonrasında da yeniden açma riski vardır.",
    IS: "İfadeci taraf katılım ve enerji yaratır, Sadık/Sabırlı taraf ilişkiyi sürdürülebilir kılar. Sıcak ve kapsayıcıdır; zor geri bildirimi ertelememek gerekir.",
    SI: "Sadık/Sabırlı taraf güveni kurar, İfadeci taraf katılımı genişletir. İnsanların sesini açan bir örüntüdür; iyimserliğin çatışmayı görünmez kılmaması gerekir.",
    IC: "İfadeci taraf fikri görünür kılar, Ciddi taraf onu kanıt ve yapıyla güçlendirir. Anlatı ile güvenilirliği birleştirir; hazırlık ile spontane akışın sınırı yönetilmelidir.",
    CI: "Ciddi taraf güvenilir zemini kurar, İfadeci taraf içeriği anlaşılır ve çekici hale getirir. Karmaşık konuları etkili aktarmaya uygundur; kusursuz hazırlık görünürlüğü geciktirmemelidir.",
    SC: "Sadık/Sabırlı taraf sürekliliği, Ciddi taraf standardı korur. Güvenilir ve dikkatli bir uygulama örüntüsüdür; değişim ve deney için bilinçli alan açılmalıdır.",
    CS: "Ciddi taraf süreci güvenceye alır, Sadık/Sabırlı taraf benimsemeyi sakinleştirir. Kalıcı düzen kurar; mükemmellik ve istikrar arayışı tempoyu gereğinden fazla düşürmemelidir."
  },
  en: {
    DI: "Direct sets direction and pace while Influencer builds commitment around the idea. The blend is decisive and persuasive; promises and follow-through need balance.",
    ID: "Influencer creates connection and energy first, then Direct converts it into a decision. It is visible and mobilising; urgency should not close the listening space.",
    DS: "Direct sets direction while Steadfast carries implementation into a stable rhythm. Pace and reassurance create productive tension that should be discussed openly.",
    SD: "Steadfast creates secure ground and Direct adds boundaries and decisions when needed. Resolve should not be delayed or arrive as sudden firmness.",
    DC: "Direct advances the decision while Cautious tests its evidence and standard. This can combine speed with quality when debate stays constructive.",
    CD: "Cautious builds the evidence frame and Direct brings closure and action. It is a strong problem-solving blend when analysis and pressure remain in balance.",
    IS: "Influencer creates energy and participation while Steadfast makes the relationship sustainable. The blend is warm and inclusive; difficult feedback should not be postponed.",
    SI: "Steadfast establishes trust and Influencer broadens participation. It helps people speak; optimism should not make conflict invisible.",
    IC: "Influencer makes the idea visible and Cautious strengthens it with evidence and structure. Narrative and credibility work together when preparation does not block flow.",
    CI: "Cautious builds a credible base and Influencer makes the content engaging. It communicates complexity well when perfect preparation does not delay visibility.",
    SC: "Steadfast protects continuity and Cautious protects standards. It is reliable and careful; experimentation and change need intentional space.",
    CS: "Cautious secures the process and Steadfast makes adoption calmer. It creates durable order; perfection and stability should not slow the pace unnecessarily."
  }
};

const TARGET_GUIDANCE = {
  tr: {
    D: {
      title: "Direk kişilerle",
      need: "Sonuç, hız, yetki alanı ve açık seçenek görmek ister.",
      do: "Önce sonucu ve beklenen kararı söyleyin; kısa seçenekler, sorumluluk ve tarih verin.",
      avoid: "Uzun giriş, belirsiz talep, tekrarlı ayrıntı ve kişiselleştirilmiş savunmadan kaçının."
    },
    I: {
      title: "İfadeci / İz Bırakan kişilerle",
      need: "İlişki, görünür ilgi, fikir alışverişi ve olumlu olasılık görmek ister.",
      do: "Sıcak başlayın, fikrini sorun, örnek ve hikâyeyle bağ kurun; sonunda net takip adımı belirleyin.",
      avoid: "Yalnız veri yığmak, katkıyı görünmez kılmak ve konuşmayı aşırı katılaştırmaktan kaçının."
    },
    S: {
      title: "Sadık / Sabırlı kişilerle",
      need: "Güven, düşünme süresi, tutarlılık ve değişimin insan etkisini görmek ister.",
      do: "Sakin ve samimi ilerleyin; değişimin nedenini, desteği ve geçiş adımlarını açıklayın.",
      avoid: "Ani baskı, sert ton, son dakika değişikliği ve sessizliği otomatik onay saymaktan kaçının."
    },
    C: {
      title: "Ciddi kişilerle",
      need: "Doğru veri, mantık, kalite ölçütü ve düşünme alanı görmek ister.",
      do: "Hazırlıklı gelin; ölçüt, kanıt, risk ve beklenen standardı düzenli biçimde sunun.",
      avoid: "Genelleme, doğrulanmamış iddia, duygusal baskı ve eksik bağlamla hızlı karar istemekten kaçının."
    }
  },
  en: {
    D: {
      title: "With Direct people",
      need: "They want outcomes, pace, authority and clear options.",
      do: "Lead with the result and decision required; give concise options, ownership and a date.",
      avoid: "Avoid long set-up, vague requests, repetitive detail and personalised defensiveness."
    },
    I: {
      title: "With Influencer people",
      need: "They want connection, visible interest, exchange and positive possibility.",
      do: "Open warmly, ask for their ideas and use examples; close with a concrete follow-up step.",
      avoid: "Avoid data-only delivery, invisible contributions and an overly rigid conversation."
    },
    S: {
      title: "With Steadfast people",
      need: "They want trust, reflection time, consistency and the human impact of change.",
      do: "Use a calm, sincere tone and explain the reason, support and transition steps.",
      avoid: "Avoid abrupt pressure, harsh tone, late change and treating silence as automatic agreement."
    },
    C: {
      title: "With Cautious people",
      need: "They want accurate data, logic, quality criteria and room to think.",
      do: "Come prepared and present evidence, risk, criteria and expected standards in an organised way.",
      avoid: "Avoid generalisations, unverified claims, emotional pressure and rushed decisions without context."
    }
  }
};

const SOURCE_TO_TARGET = {
  tr: {
    D: {
      D: "Doğal kısalığınızı koruyun; konuşmayı güç yarışına çevirmeden yetki sınırını netleştirin.",
      I: "Sonuca koşmadan önce ilişki ve fikir paylaşımına görünür alan açın.",
      S: "Hızınızı düşürün, düşünme süresi tanıyın ve değişimin güvenliğini anlatın.",
      C: "Karar baskısından önce veri ve kalite ölçütünü paylaşın."
    },
    I: {
      D: "Önce sonuç ve talebi söyleyin; hikâye ve ayrıntıyı sonra ekleyin.",
      I: "Enerjiyi paylaşın fakat konuşmayı bir karar ve takip adımıyla kapatın.",
      S: "Sıcaklığınızı koruyun; tempoyu düşürüp söz kesmeden dinleyin.",
      C: "Coşkuyu kanıtla destekleyin; mesajı düzenleyip genellemeleri azaltın."
    },
    S: {
      D: "Nezaketi korurken talebinizi ve sınırınızı daha erken, daha doğrudan söyleyin.",
      I: "Destekleyici tavrınıza görünür enerji ve açık takdir ekleyin.",
      S: "Güvenli ritminizi kullanın; anlaşmazlığı örtmeden gerçek görüşünüzü de söyleyin.",
      C: "Sabırlı yaklaşımınızı veri, ölçüt ve yazılı takip ile güçlendirin."
    },
    C: {
      D: "Analizin sonucunu ilk cümlede verin; gerekli ayrıntıyı kararın arkasına koyun.",
      I: "Veriyi insan etkisi ve kısa bir örnekle canlandırın; mesafeyi biraz azaltın.",
      S: "Doğruluğun yanında güvence, sabır ve değişim desteğini de görünür kılın.",
      C: "Ortak ölçütü baştan belirleyin; ayrıntıda kaybolmadan karar zamanını netleştirin."
    }
  },
  en: {
    D: {
      D: "Keep your natural brevity, but clarify authority without turning the exchange into a contest.",
      I: "Create visible room for connection and idea-sharing before driving to the outcome.",
      S: "Slow the pace, allow reflection and explain the security around change.",
      C: "Share evidence and quality criteria before applying decision pressure."
    },
    I: {
      D: "State the result and ask first; add story and detail afterwards.",
      I: "Share energy, then close with a decision and follow-up step.",
      S: "Keep the warmth, lower the pace and listen without interrupting.",
      C: "Support enthusiasm with evidence and reduce generalisations."
    },
    S: {
      D: "Keep the courtesy while stating your ask and boundary earlier and more directly.",
      I: "Add visible energy and explicit recognition to your supportive approach.",
      S: "Use your steady rhythm while making genuine disagreement visible.",
      C: "Strengthen patience with data, criteria and written follow-through."
    },
    C: {
      D: "Give the analytical conclusion first and place detail behind the decision.",
      I: "Bring the data to life with human impact and a brief example.",
      S: "Make reassurance, patience and transition support as visible as accuracy.",
      C: "Agree criteria early and set a decision time so detail does not take over."
    }
  }
};

export function getScoreLevel(score) {
  return getScoreBand(score).key;
}

export function getScoreBand(score, language = "tr") {
  const value = clampScore(score);
  const band = SCORE_BANDS.find((item) => value >= item.min && value <= item.max) || SCORE_BANDS[SCORE_BANDS.length - 1];
  const lang = language === "en" ? "en" : "tr";
  return { ...band, value, label: band[lang] };
}

export function getDifferenceBand(delta, language = "tr") {
  const lang = language === "en" ? "en" : "tr";
  const distance = Math.abs(Number(delta) || 0);
  if (distance <= 15) {
    return { key: "close", distance, label: lang === "tr" ? "Doğal hale yakın" : "Close to the natural state" };
  }
  if (distance <= 30) {
    return { key: "far", distance, label: lang === "tr" ? "Doğal halden uzak" : "Far from the natural state" };
  }
  return { key: "veryFar", distance, label: lang === "tr" ? "Doğal halden çok uzak" : "Very far from the natural state" };
}

export function getDiscName(key, language = "tr") {
  const lang = language === "en" ? "en" : "tr";
  return STYLE_NAMES[lang][key] || key;
}

export function buildDiscReport({ adaptedScores, naturalScores, participant = {}, language = "tr" }) {
  const lang = language === "en" ? "en" : "tr";
  const adapted = normalizeScores(adaptedScores);
  const natural = normalizeScores(naturalScores);
  const adaptedSorted = sortScores(adapted);
  const naturalSorted = sortScores(natural);
  const activeAdapted = adaptedSorted.filter((item) => item.value >= 50);
  const activeNatural = naturalSorted.filter((item) => item.value >= 50);
  const lead = activeAdapted[0] || adaptedSorted[0];
  const topValue = lead?.value ?? 0;
  const equalLeads = activeAdapted.filter((item) => item.value === topValue);
  const nearCluster = activeAdapted.filter((item) => topValue - item.value <= 5);
  const deltas = Object.fromEntries(DISC_LABELS.map((key) => [key, Math.round(adapted[key] - natural[key])]));
  const differences = DISC_LABELS.map((key) => buildDifferenceRow(key, adapted[key], natural[key], deltas[key], lang));
  const support = adaptedSorted.find((item) => item.key !== lead?.key) || adaptedSorted[1];
  const lowest = adaptedSorted[adaptedSorted.length - 1];
  // DİP beraberliği de TEPE beraberliği kadar önemlidir: "en düşük kanalınız C"
  // demek, C ile eşit olan D'yi görünmez kılar.
  const equalLowest = adaptedSorted.filter((item) => item.value === (lowest?.value ?? -1));
  // equalLeads YALNIZ eşik üstünden hesaplanır; hiçbir sinyal %50'yi geçmediğinde
  // boş kalır ve beraberlik görünmez olurdu. Eşikten bağımsız tepe beraberliği:
  const topValueAll = adaptedSorted[0]?.value ?? 0;
  const equalLeadsAll = adaptedSorted.filter((item) => item.value === topValueAll);
  // Dördü de aynı yüzde. Şablon tablosuna göre bu YALNIZCA belirli değerlerde
  // mümkündür (uyarlanmış %95/%97.5 · doğal %0/%5/%97.5) — nadir ama gerçek.
  const allEqual = adaptedSorted.length > 0 &&
    adaptedSorted.every((item) => item.value === adaptedSorted[0].value);
  const naturalLead = naturalSorted[0];
  const naturalSupport = naturalSorted[1];
  const profile = {
    code: activeAdapted.map((item) => item.key).join("") || "<50",
    active: activeAdapted,
    lead,
    support,
    lowest,
    equalLeads,
    nearCluster,
    hasEqualLead: equalLeads.length > 1,
    hasNearCluster: nearCluster.length > 1,
    equalLowest,
    hasEqualLowest: equalLowest.length > 1 && !allEqual,
    equalLeadsAll,
    hasEqualLeadAll: equalLeadsAll.length > 1,
    allEqual,
    orderedAll: adaptedSorted,
    leadGap: Math.max(0, (lead?.value || 0) - (support?.value || 0)),
    spread: Math.max(0, (adaptedSorted[0]?.value || 0) - (lowest?.value || 0)),
    shape: getProfileShape(activeAdapted, lead, support, lang),
    naturalLead,
    naturalSupport,
    naturalOrderedAll: naturalSorted,
    // ── literatür katmanı (bkz. discLiterature.js) ──────────────────────
    bicimGucu: bicimGucu(adapted),
    oruntu: oruntuBul(adapted, lang),          // uyarlanmış grafiğin klasik örüntüsü
    oruntuDogal: oruntuBul(natural, lang),     // doğal grafiğin klasik örüntüsü
    eksen: marstonEksenleri(adapted, lang),
    eksenDogal: marstonEksenleri(natural, lang),
    enerji: uyarlamaEnerjisi(adapted, natural, lang)
  };
  const sections = DISC_LABELS.map((key) => buildDimensionSection(key, adapted[key], natural[key], deltas[key], lang, profile));

  return {
    language: lang,
    participant,
    adapted,
    natural,
    deltas,
    differences,
    sections,
    activeAdapted,
    activeNatural,
    primary: lead?.key || "D",
    secondary: activeAdapted[1]?.key || adaptedSorted[1]?.key || "I",
    lowest: adaptedSorted[adaptedSorted.length - 1]?.key || "C",
    naturalPrimary: naturalSorted[0]?.key || "D",
    profile,
    title: lang === "tr" ? "Someren Labs DISC Kişiselleştirilmiş Raporu" : "Someren Labs Personalised DISC Report",
    profileTitle: buildProfileTitle(profile, lang),
    executiveSummary: buildExecutiveSummary(profile, differences, participant, lang),
    teamFit: buildTeamFit(profile, lang),
    adaptedProfileSummary: buildAdaptedSummary(profile, lang),
    naturalProfileSummary: buildNaturalSummary(profile, activeNatural, lang),
    workStyle: buildWorkStyle(profile, lang),
    decisionStyle: buildDecisionStyle(profile, lang),
    combinationNarrative: buildCombinationNarrative(profile, lang),
    // Karşılıklı algı: aynı davranış karşıdakinin sinyaline göre farklı okunur.
    perceptionReadings: algiOkumalari(profile.lead.key, lang),
    adaptationInsight: buildAdaptationInsight(differences, profile, lang),
    strengths: buildStrengths(profile, lang),
    watchouts: buildWatchouts(profile, adaptedSorted, lang),
    communicationTips: buildSelfCommunicationTips(profile, lang),
    communicationGuide: buildCommunicationGuide(profile, lang),
    managerNotes: buildManagerNotes(profile, differences, participant, lang),
    hrNotes: buildHrNotes(profile, lang),
    developmentPlan: buildDevelopmentPlan(profile, differences, lang),
    profileArchitecture: buildProfileArchitecture(profile, differences, lang),
    scenarioReadings: buildScenarioReadings(profile, lang),
    patternReading: buildPatternReading(profile, lang),
    axisReading: buildAxisReading(profile, lang),
    adaptationEnergy: buildAdaptationEnergy(profile, lang),
    methodology: buildMethodology(lang),
    evidenceNotes: buildEvidenceNotes(lang)
  };
}

function buildProfileTitle(profile, lang) {
  if (!profile.active.length) {
    return lang === "tr"
      ? `${profile.shape}: ${profile.lead.key}${profile.lead.value} / ${profile.support.key}${profile.support.value}`
      : `${profile.shape}: ${profile.lead.key}${profile.lead.value} / ${profile.support.key}${profile.support.value}`;
  }
  const signature = profile.active.map((item) => `${item.key}${item.value}`).join("-");
  return `${PROFILE_TITLES[lang][profile.lead.key]} · ${signature}`;
}


// ══════════════════════════════════════════════════════════════════════════════
// TAKIM ETKİSİ · "Sizi kim tamamlar"
//
// Referansın 8. sayfasındaki "Takım etkisi" kutusunun karşılığı. Orada tek cümle
// vardı ("Analitik ve sabırlı profillerle eşleştiğinde…"); burada okuma KİŞİNİN
// KENDİ SAYILARINDAN üretilir.
//
// Bu bir KİŞİLİK UYUMU okuması DEĞİLDİR — kanal kapsamasıdır. İddia şu: profilde
// en az görünen kanalı, onu doğal taşıyan biri kapatır.
//
// Harita (discBrand.js ile birebir): sol-üst D · sağ-üst I · sol-alt C · sağ-alt S
//   aynı satır  = aynı TEMPO   ·   aynı sütun = aynı ODAK   ·   köşegen = ikisi de farklı
const HARITA_KOMSU = {
  D: { ayniTempo: "I", ayniOdak: "C", capraz: "S" },
  I: { ayniTempo: "D", ayniOdak: "S", capraz: "C" },
  C: { ayniTempo: "S", ayniOdak: "D", capraz: "I" },
  S: { ayniTempo: "C", ayniOdak: "I", capraz: "D" },
};

// Cümle başı büyük harf (Türkçe "ı" -> "I" tuzağı yok; ilk harf zaten a/s)
const bbh = (t) => (t ? t.charAt(0).toLocaleUpperCase("tr-TR") + t.slice(1) : t);

function buildTeamFit(profile, lang) {
  const tr = lang === "tr";
  const lider = profile.lead.key;
  const k = HARITA_KOMSU[lider];
  const tamamlayan = profile.lowest.key;
  const tamamlayanDeger = profile.lowest.value;

  // "En kolay eşleştiğiniz": aynı tempo / aynı odak komşularından tamamlayan
  // OLMAYANI; ikisi de uygunsa kişinin kendi profilinde daha yüksek olanı.
  const adaylar = [k.ayniTempo, k.ayniOdak].filter((x) => x !== tamamlayan);
  const puan = Object.fromEntries(profile.orderedAll.map((x) => [x.key, x.value]));
  const kolay = adaylar.length
    ? adaylar.sort((a, b) => (puan[b] || 0) - (puan[a] || 0))[0]
    : k.ayniTempo;
  const kolayEksen = kolay === k.ayniTempo
    ? (tr ? "aynı tempo, farklı odak" : "same pace, different focus")
    : (tr ? "aynı odak, farklı tempo" : "same focus, different pace");

  // Tamamlayan kanal haritada nerede duruyor? Gerilim cümlesi buradan çıkar.
  let gerilim;
  if (tamamlayan === k.capraz) {
    gerilim = tr
      ? "Bu eşleşmenin özel bir yanı var: sizi tamamlayan kanal, haritada size en uzak duran kanal. Yani en çok kapsayan kişi, aynı zamanda en çok tercüme gerektiren kişidir."
      : "This pairing has a particular twist: the channel that completes you is the one furthest from you on the map. The person who covers you most is also the one who needs the most translating.";
  } else if (tamamlayan === k.ayniTempo) {
    gerilim = tr
      ? "Haritada bu kanal sizinle aynı tempodadır ama farklı odaktadır: hızda kolayca anlaşırsınız, neyi önce konuşacağınızda ayrılırsınız."
      : "On the map this channel shares your pace but not your focus: you agree easily on speed and part ways on what comes first.";
  } else {
    gerilim = tr
      ? "Haritada bu kanal sizinle aynı odakta durur ama farklı tempodadır: önceliklerde kolayca anlaşırsınız, hızda sürtünürsünüz. Bu yüzden böyle bir çalışma arkadaşı size hem en çok yarayan hem de en çok sabır isteyen eşleşmedir."
      : "On the map this channel shares your focus but not your pace: you agree easily on priorities and rub against each other on speed. That makes such a colleague both the most useful and the most patience-demanding pairing.";
  }

  const ad = (x) => `${x} · ${STYLE_NAMES[lang][x].split(" / ")[tr ? 1 : 0] || x}`;

  // Tamamlayan ile çapraz AYNI harfe düşebilir (lider I ise ikisi de C, lider S ise
  // ikisi de D). O zaman üç kart yerine iki kart basılır; yoksa aynı harf iki kez
  // görünür ve hata gibi okunur. Gerilim cümlesi zaten bu durumu anlatıyor.
  const birlesik = tamamlayan === k.capraz;

  return {
    lider,
    tamamlayan,
    kolay,
    capraz: k.capraz,
    birlesik,
    intro: tr
      ? "Bu okuma kişilik uyumu değil, kanal kapsaması üzerine kuruludur. Haritada nerede durduğunuz, hangi kanalın sizde en az göründüğünü ve bunu kimin doğal olarak taşıdığını gösterir."
      : "This reading is about channel coverage, not personality compatibility. Where you sit on the map shows which channel is least visible in you, and who carries it naturally.",
    tamamlayanBaslik: tr ? `Sizi tamamlayan: ${ad(tamamlayan)} (%${tamamlayanDeger})`
                         : `What completes you: ${ad(tamamlayan)} (${tamamlayanDeger}%)`,
    tamamlayanMetin: tr
      ? `Profilinizin en az görünen kanalı bu. ${tamamlayan} sinyali yüksek biriyle çalıştığınızda, ${STYLE_CONTENT.tr[tamamlayan].contribution.toLocaleLowerCase("tr-TR")} tarafı devreye girer. Bu kişi sizi yavaşlatmaz; kararınızın arkasındaki zemini genişletir.`
      : `This is the least visible channel in your profile. Working with someone whose ${tamamlayan} signal is high brings in ${STYLE_CONTENT.en[tamamlayan].contribution.toLowerCase()}. Such a person does not slow you down; they widen the ground beneath your decision.`,
    gerilim,
    kolayBaslik: tr ? `En kolay eşleştiğiniz: ${ad(kolay)}` : `Easiest pairing: ${ad(kolay)}`,
    kolayMetin: tr
      ? `${bbh(kolayEksen)}. Bu kanal sizde ${puan[kolay]}% düzeyinde, yani ortak dili kurmak zorlanmadan olur.`
      : `${bbh(kolayEksen)}. This channel sits at ${puan[kolay]}% in your own profile, so finding a common language takes little effort.`,
    caprazBaslik: tr ? `En çok çeviri gereken: ${ad(k.capraz)}` : `Needs the most translating: ${ad(k.capraz)}`,
    caprazMetin: tr
      ? `Haritada çapraz durur: hem tempo hem odak farklı. Bu bir uyumsuzluk değil, en çok tercüme gerektiren eşleşmedir. ${k.capraz} sinyali yüksek biriyle çalışırken hızınızı ayarlamak yetmez; neyi önce söylediğinizi de değiştirmeniz gerekir.`
      : `It sits diagonally on the map: both pace and focus differ. This is not incompatibility, it is the pairing that needs the most translating. With someone whose ${k.capraz} signal is high, adjusting your speed is not enough — you also have to change what you say first.`,
    soru: tr
      ? `"Bu kararda ${tamamlayan}'nin sorduğu soruyu kim soruyor?"`
      : `"Who is asking ${tamamlayan}'s question in this decision?"`,
    soruEtiketi: tr ? "Ekibe sorulacak soru" : "The question to put to the team",
  };
}

function buildExecutiveSummary(profile, differences, participant, lang) {
  if (!profile.active.length) {
    // Eşik altı profilde de beraberlik gizlenmemeli: "X ilk, Y ikinci" demek,
    // X ile Y aynı yüzdedeyse yanlıştır.
    const tepe = profile.hasEqualLeadAll
      ? (lang === "tr"
          ? `En yüksek ana davranış sinyalleri ${joinKeys(profile.equalLeadsAll.map((i) => i.key), lang)}; ${profile.lead.value}% ile eşittir.`
          : `The profile is led jointly by ${joinKeys(profile.equalLeadsAll.map((i) => i.key), lang)} at ${profile.lead.value}%.`)
      : (lang === "tr"
          ? `${profile.lead.key} ${profile.lead.value}% ile ilk, ${profile.support.key} ${profile.support.value}% ile ikinci sıradadır ve aralarında ${profile.leadGap} puan vardır.`
          : `${profile.lead.key} at ${profile.lead.value}% leads ${profile.support.key} at ${profile.support.value}% by ${profile.leadGap} points.`);
    const dipAlt = profile.hasEqualLowest
      ? (lang === "tr"
          ? `En düşük uyarlanmış sinyaller ${joinKeys(profile.equalLowest.map((i) => i.key), lang)}; ${profile.lowest.value}% ile eşittir.`
          : `The lowest adapted signals are ${joinKeys(profile.equalLowest.map((i) => i.key), lang)} at ${profile.lowest.value}%.`)
      : (lang === "tr"
          ? `En düşük ${profile.lowest.key} ${profile.lowest.value}% alanı ise zorlandığında bilinçli destek isteyebilecek kanalı gösterir.`
          : `The lowest ${profile.lowest.key} signal at ${profile.lowest.value}% may need deliberate support.`);
    return lang === "tr"
      ? `Uyarlanmış profilde hiçbir sinyal %50 eşiğini geçmiyor. Yine de profil nötr değildir: ${tepe} Bu kişi tek bir varsayılanı sürekli öne çıkarmaktan çok, bağlama göre davranış seçiyor olabilir. ${dipAlt}`
      : `No adapted signal reaches 50%. The profile is still not neutral: ${tepe} Behaviour may be selected by context rather than one constant default. ${dipAlt}`;
  }


  const ordered = profile.active.map((item) => `${item.key} ${item.value}%`).join(" > ");

  // ── ÇOK KANALLILIK ─────────────────────────────────────────────────────────
  // Ajlan'ın çerçevesi (2026-08-21): birden fazla sinyalin %50 üzerinde olması
  // bir dağınıklık DEĞİL, bir genişliktir. Telsiz benzetmesi: aynı anda birden
  // fazla frekanstan yayın yapıp alabilmek. Rapor bunu eksiklik gibi anlatmaz.
  const cokKanal = profile.active.length >= 2
    ? (lang === "tr"
        ? ` ${profile.active.length} kanalın birden eşiği geçmesi dağınıklık değil genişliktir: kişi aynı anda birden fazla frekanstan yayın yapıp alabiliyor, karşısındaki hangi dili konuşuyorsa ona geçebiliyor demektir.`
        : ` Having ${profile.active.length} channels above the threshold is range rather than scatter: the person can transmit and receive on more than one frequency at once, and can switch to whichever language the other person speaks.`)
    : "";

  // ── A) DÖRDÜ DE AYNI DÜZEYDE ───────────────────────────────────────────────
  if (profile.allEqual) {
    const deger = profile.orderedAll[0].value;
    return lang === "tr"
      ? `Bu profilde dört sinyal de aynı düzeydedir (%${deger}); tek bir ana davranış sinyalinden söz edilemez. Bu bir belirsizlik değil, ölçümün verdiği cevaptır: D, I, S ve C eşit yükseklikte durur ve kişi hangi kanalı kullanacağını duruma göre seçiyor olabilir.${cokKanal} Böyle bir profilde konuşulacak soru "hangi stil" değil, "hangi durumda hangisine geçiyorsunuz" sorusudur. ${buildRolePhrase(participant?.roleLevel, lang)}`
      : `All four signals are at the same level in this profile (${deger}%), so no single leading behaviour signal can be named. This is not ambiguity but the measurement's answer: D, I, S and C stand at equal height and the channel may be chosen by situation.${cokKanal} The question here is not "which style" but "in which situation do you switch to which".  ${buildRolePhrase(participant?.roleLevel, lang)}`;
  }

  // ── B) AÇILIŞ — tepe beraberliği varsa tek lider İDDİA EDİLMEZ ─────────────
  const acilis = profile.hasEqualLead
    ? (lang === "tr"
        ? `Bu profilin ana davranış sinyalleri ${joinKeys(profile.equalLeads.map((i) => i.key), lang)}; ${profile.lead.value}% ile eşit yüksekliktedir ve hiçbiri diğerinin önünde değildir.`
        : `This profile is led jointly by ${joinKeys(profile.equalLeads.map((i) => i.key), lang)} at ${profile.lead.value}%, with none ahead of the other.`)
    : (lang === "tr"
        ? `Bu profilin ilk davranış dürtüsü ${profile.lead.key} ${profile.lead.value}%: ${STYLE_SCENARIOS.tr[profile.lead.key].portrait}`
        : `The first behavioural impulse is ${profile.lead.key} at ${profile.lead.value}%: ${STYLE_SCENARIOS.en[profile.lead.key].portrait}`);

  // ── C) YAKIN KÜME (beraberlik yoksa) ───────────────────────────────────────
  const cluster = profile.hasEqualLead
    ? ""
    : profile.hasNearCluster
      ? (lang === "tr"
          ? `${joinKeys(profile.nearCluster.map((i) => i.key), lang)} arasında 5 puanı aşmayan bir yakın küme vardır; bağlam, bu küme içinde hangi davranışın öne çıkacağını değiştirebilir. `
          : `${joinKeys(profile.nearCluster.map((i) => i.key), lang)} form a near cluster within five points, so context may shift which behaviour leads. `)
      : (lang === "tr" ? `${profile.lead.key} sinyali profilde açık biçimde öndedir. ` : `${profile.lead.key} is the clear leading signal. `);

  // ── D) DİP — beraberlik varsa tek "en düşük" İDDİA EDİLMEZ ────────────────
  const dip = profile.hasEqualLowest
    ? (lang === "tr"
        ? `En düşük uyarlanmış sinyaller ${joinKeys(profile.equalLowest.map((i) => i.key), lang)}; ${profile.lowest.value}% ile eşittir, aralarında bir sıra yoktur.`
        : `The lowest adapted signals are ${joinKeys(profile.equalLowest.map((i) => i.key), lang)} at ${profile.lowest.value}%, with no order between them.`)
    : (lang === "tr"
        ? `${profile.lowest.key} ${profile.lowest.value}% en az görünür kanaldır; özellikle ${STYLE_CONTENT.tr[profile.lowest.key].underuse.toLocaleLowerCase("tr-TR")}`
        : `${profile.lowest.key} at ${profile.lowest.value}% is least visible.`);

  const supportStatus = profile.support.value >= 50
    ? (lang === "tr" ? "ikinci ana kanal" : "second active channel")
    : profile.support.value >= 40
      ? (lang === "tr" ? "eşik altındaki en yakın destek kanalı" : "closest support channel below threshold")
      : (lang === "tr" ? "arka planda kalan destek kanalı" : "background support channel");
  const naturalDelta = differences.find((item) => item.key === profile.lead.key);
  const role = buildRolePhrase(participant?.roleLevel, lang);

  // Beraberlikte "lider ile destek arasındaki fark" cümlesi anlamsızdır (fark 0).
  const farkCumlesi = profile.hasEqualLead
    ? ""
    : (lang === "tr"
        ? `${profile.lead.key} ile ${profile.support.key} arasındaki ${profile.leadGap} puanlık fark, ${profile.shape.toLocaleLowerCase("tr-TR")} bir yapı gösterir. `
        : `The ${profile.leadGap}-point lead and ${profile.spread}-point spread create a ${profile.shape.toLowerCase()} structure. `);

  const destekCumlesi = profile.hasEqualLead
    ? ""
    : (lang === "tr"
        ? `${profile.support.key} ${profile.support.value}% ${supportStatus} olarak ana davranışı ${STYLE_CONTENT.tr[profile.support.key].contribution.toLocaleLowerCase("tr-TR")} yönünden tamamlar. `
        : `${profile.support.key} at ${profile.support.value}% is the ${supportStatus}. `);

  return lang === "tr"
    ? `${acilis} %50 üzerindeki sıra ${ordered}; ${cluster}${destekCumlesi}${farkCumlesi}${dip} ${profile.lead.key} doğal/uyarlanmış farkı ${formatDelta(naturalDelta.delta)} puandır ve ${naturalDelta.distance.label.toLocaleLowerCase("tr-TR")}; bu nedenle öndeki davranışın yalnızca geçici bir rol maskesi olduğu söylenemez.${cokKanal} ${role}`
    : `${acilis} The 50+ order is ${ordered}; ${cluster}${destekCumlesi}${farkCumlesi}${dip} The lead natural/adapted difference is ${formatDelta(naturalDelta.delta)} and ${naturalDelta.distance.label.toLowerCase()}.${cokKanal} ${role}`;
}

function buildAdaptedSummary(profile, lang) {
  if (!profile.active.length) {
    return lang === "tr"
      ? "Uyarlanmış profil kişinin şu anki mevcut halini anlatır. Dört sinyal de %50 altında olduğundan, kişi davranışını durumun ihtiyacına göre seçiyor olabilir; güçlü bir varsayılanı olduğunu söylemek için veri yeterli değildir."
      : "The adapted profile describes the person’s current state. Because all four signals are below 50, behaviour may be selected according to the situation and the data do not justify claiming a strong default.";
  }
  const bands = profile.active.map((item) => `${item.key} ${item.value}% (${getScoreBand(item.value, lang).label.toLocaleLowerCase(lang === "tr" ? "tr-TR" : "en-US")})`);
  return lang === "tr"
    ? `Uyarlanmış profil kişinin şu anki mevcut halidir. Ana konuşulan ${joinKeys(profile.active.map((item) => item.key), lang)} sinyalleri ${bands.join(", ")}. İlk sıradaki ${profile.lead.key}, ikinci sıradaki ${profile.support.key} sinyalinden ${profile.leadGap} puan; en düşük ${profile.lowest.key} sinyalinden ${profile.spread} puan öndedir. Bu nedenle profil ${profile.shape.toLocaleLowerCase("tr-TR")} okunur. ${profile.support.value < 50 ? `${profile.support.key} ana stil değildir; yine de ${profile.support.value}% ile en yakın tamamlayıcı kaynaktır.` : `${profile.support.key} de ana konuşulan davranışlar arasındadır ve lider davranışın tek başına çalışmasını engeller.`}`
    : `The adapted profile is the current state. Active signals are ${bands.join(", ")}. ${profile.lead.key} leads ${profile.support.key} by ${profile.leadGap} points and the lowest ${profile.lowest.key} by ${profile.spread} points, creating a ${profile.shape.toLowerCase()} structure. ${profile.support.value < 50 ? `${profile.support.key} is not a lead style but is the closest supporting resource.` : `${profile.support.key} is also active and keeps the lead style from operating alone.`}`;
}

function buildNaturalSummary(profile, activeNatural, lang) {
  const ordered = activeNatural.map((item) => `${item.key} ${item.value}%`).join(" > ");
  if (!activeNatural.length) {
    return lang === "tr"
      ? "Someren Labs yorumlama çerçevesinde doğal profil, yaşamın ilk yıllarında - özellikle 0-7 yaş döneminde - şekillenmeye başlayan temel eğilimlerin ve daha zahmetsiz davranış tercihlerinin izi olarak ele alınır. Burada hiçbir sinyal %50 üzerinde değildir; bu nedenle tek bir 'öz stil' iddiası yerine dört boyutun birlikte okunması gerekir."
      : "In the Someren Labs interpretation framework, the natural profile is treated as a trace of foundational tendencies that begin forming in the early years, especially ages 0-7, and of less effortful behavioural preferences. No signal is above 50 here, so all four dimensions should be read together rather than claiming one core style.";
  }
  return lang === "tr"
    ? `Someren Labs çerçevesinde doğal profil, yaşamın ilk yıllarında - özellikle 0-7 yaş döneminde - şekillenmeye başlayan temel eğilimlerin ve daha zahmetsiz tercihlerin izi olarak ele alınır. Doğal sıra ${ordered}; ilk iki kanal ${profile.naturalLead.key} ${profile.naturalLead.value}% ve ${profile.naturalSupport.key} ${profile.naturalSupport.value}% düzeyindedir. Uyarlanmış profilin lideri ${profile.lead.key}, doğal profilde ${profile.naturalOrderedAll.find((item) => item.key === profile.lead.key)?.value}% görünürdür. Bu eşleşme, mevcut davranışın ne kadar zahmetsiz veya bağlamsal olabileceğini tartışmak için kullanılır. 0-7 ifadesi gelişim metaforudur; kişiliğin yedi yaşında donduğu iddiası değildir.`
    : `The natural profile is treated as a trace of foundational preferences beginning in the early years. The 50+ natural order is ${ordered}; the first two channels are ${profile.naturalLead.key} ${profile.naturalLead.value}% and ${profile.naturalSupport.key} ${profile.naturalSupport.value}%. The adapted lead ${profile.lead.key} appears at ${profile.naturalOrderedAll.find((item) => item.key === profile.lead.key)?.value}% naturally. Ages 0-7 is a development metaphor, not a claim that personality freezes at seven.`;
}

function buildCombinationNarrative(profile, lang) {
  if (profile.active.length < 2) {
    if (!profile.active.length) {
      return lang === "tr"
        ? `${profile.lead.key} ${profile.lead.value}% ve ${profile.support.key} ${profile.support.value}% eşik altında kalan ilk iki kanaldır. Aralarındaki ${profile.leadGap} puanlık fark nedeniyle tek bir ana stil iddiası kurulmaz; ${profile.lead.key} ilk refleksi, ${profile.support.key} ise bağlama göre devreye giren ikinci seçeneği anlatır. ${profile.lowest.key} ${profile.lowest.value}% alanı özellikle bilinçli yapı isteyebilir.`
        : `${profile.lead.key} ${profile.lead.value}% and ${profile.support.key} ${profile.support.value}% are the first two sub-threshold channels. Their ${profile.leadGap}-point gap does not justify one lead style; ${profile.lead.key} is the first tendency and ${profile.support.key} the contextual second option.`;
    }
    const style = STYLE_CONTENT[lang][profile.active[0].key];
    return lang === "tr"
      ? `Profil tek ana sinyalle konuşuyor: ${profile.lead.key} ${profile.lead.value}% ile ${style.core}. Bununla birlikte ${profile.support.key} ${profile.support.value}% eşik altındaki en yakın destek kanalıdır ve ana davranışa ${STYLE_CONTENT.tr[profile.support.key].contribution.toLocaleLowerCase("tr-TR")} ekleyebilir. ${profile.leadGap} puanlık fark, desteğin kendiliğinden değil daha çok ihtiyaç olduğunda devreye gireceğini düşündürür. ${profile.lowest.key} ${profile.lowest.value}% ise ana stilin kör noktasını büyütebilecek en az görünür kanaldır.`
      : `The profile speaks through one lead signal: ${profile.lead.key} ${profile.lead.value}% and ${style.core}. ${profile.support.key} ${profile.support.value}% is the nearest sub-threshold support channel, while ${profile.lowest.key} ${profile.lowest.value}% is the least visible channel and may enlarge the lead style's blind spot.`;
  }

  const [first, second, ...rest] = profile.active;
  const pair = PAIR_NARRATIVES[lang][`${first.key}${second.key}`];
  if (!rest.length) {
    return lang === "tr"
      ? `${pair} İlk iki stil arasındaki fark ${profile.leadGap} puandır; ${profile.lowest.key} ${profile.lowest.value}% bu bileşimin en az kendiliğinden kullandığı kanaldır.`
      : `${pair} The first two styles are ${profile.leadGap} points apart; ${profile.lowest.key} ${profile.lowest.value}% is the least spontaneous channel in the blend.`;
  }
  const modifiers = rest.map((item) => {
    const contribution = STYLE_CONTENT[lang][item.key].contribution;
    return lang === "tr"
      ? `${item.key} (${item.value}%) bu bileşime ${contribution.toLocaleLowerCase("tr-TR")} katmanı ekler`
      : `${item.key} (${item.value}%) adds ${contribution.toLowerCase()} to this blend`;
  });
  return `${pair} ${modifiers.join("; ")}. ${lang === "tr" ? `${profile.lowest.key} ${profile.lowest.value}% en az görünür denge kanalıdır.` : `${profile.lowest.key} ${profile.lowest.value}% is the least visible balancing channel.`}`;
}

// 2026-08-21: workStyle ve decisionStyle SIRAYA bakıyordu, YÜKSEKLİĞE değil —
// D %95 ile D %55 aynı metni üretiyordu. Referans PDF'i skoru cümleye döküyor
// ("I %85 seviyesinde…"). Liderin bandı artık cümlenin şiddetini belirler.
function liderSiddeti(deger, lang) {
  const bant = getScoreLevel(deger);
  if (bant === "veryHigh") return lang === "tr"
    ? "Bu sinyal profilde çok belirgindir; davranış neredeyse her durumda buradan başlar. "
    : "This signal is very pronounced; behaviour starts here in almost every situation. ";
  if (bant === "high") return lang === "tr"
    ? "Bu sinyal belirgindir; çoğu durumda ilk tepki buradan gelir. "
    : "This signal is pronounced; the first response usually comes from here. ";
  return lang === "tr"
    ? "Bu sinyal eşiğin hemen üzerindedir; ilk tepki buradan gelir ama bağlam kolayca başka bir kanala kaydırabilir. "
    : "This signal sits just above the threshold; it leads, but context can easily shift behaviour to another channel. ";
}

function buildWorkStyle(profile, lang) {
  if (!profile.active.length) {
    return lang === "tr"
      ? "Çalışma tarzı tek bir davranış üzerinden tahmin edilmemelidir. Net hedef, rol beklentisi ve gözlenen gerçek örnekler raporla birlikte konuşulmalıdır."
      : "Work style should not be inferred from one behaviour. Clear goals, role expectations and observed examples should be discussed alongside the report.";
  }
  const supportClause = profile.support.value >= 50
    ? (lang === "tr" ? `${profile.support.key} ${profile.support.value}% ikinci aktif kanal olarak ${STYLE_CONTENT.tr[profile.support.key].work.toLocaleLowerCase("tr-TR")}` : `${profile.support.key} ${profile.support.value}% is a second active channel: ${STYLE_CONTENT.en[profile.support.key].work}`)
    : (lang === "tr" ? `${profile.support.key} ${profile.support.value}% ana stil eşiğinin altında olsa da ${STYLE_CONTENT.tr[profile.support.key].contribution.toLocaleLowerCase("tr-TR")} gerektiğinde kullanılabilecek en yakın kaynaktır.` : `${profile.support.key} ${profile.support.value}% is below the lead threshold but remains the nearest supporting resource.`);
  const siddet = liderSiddeti(profile.lead.value, lang);
  return lang === "tr"
    ? `${STYLE_CONTENT.tr[profile.lead.key].work} ${siddet}${STYLE_SCENARIOS.tr[profile.lead.key].meeting} ${supportClause} En düşük ${profile.lowest.key} ${profile.lowest.value}% nedeniyle ${STYLE_CONTENT.tr[profile.lowest.key].underuse.toLocaleLowerCase("tr-TR")}`
    : `${STYLE_CONTENT.en[profile.lead.key].work} ${siddet}${STYLE_SCENARIOS.en[profile.lead.key].meeting} ${supportClause} The lowest ${profile.lowest.key} signal means ${STYLE_CONTENT.en[profile.lowest.key].underuse.toLowerCase()}`;
}

function buildDecisionStyle(profile, lang) {
  if (!profile.active.length) {
    return lang === "tr"
      ? "Karar yaklaşımı bağlama göre değişebilir; hız, insan etkisi, süreklilik ve kanıt ölçütlerinin hangisinin öne alınacağı açıklaştırılmalıdır."
      : "The decision approach may change with context; clarify whether speed, people impact, continuity or evidence should lead.";
  }
  // ONARIM 2026-08-17: en düşük kanal her zaman "düşük" DEĞİLDİR. Dördü de 80-90
  // olan profilde motor "C 80% düşük kaldığında ..." yazıyordu. Cümle artık bandına
  // göre kuruluyor. Ayrıca kontrol sorusu noktalamasız yapıştırılıyordu.
  const enDusukBant = getScoreLevel(profile.lowest.value);
  const enDusukCumle = ["low", "veryLow"].includes(enDusukBant)
    ? (lang === "tr"
        ? `${profile.lowest.key} ${profile.lowest.value}% düşük kaldığı için ${STYLE_CONTENT.tr[profile.lowest.key].underuse.toLocaleLowerCase("tr-TR")}`
        : `Because ${profile.lowest.key} stays at ${profile.lowest.value}%, ${STYLE_CONTENT.en[profile.lowest.key].underuse.toLowerCase()}`)
    : (lang === "tr"
        ? `${profile.lowest.key} ${profile.lowest.value}% profilin en alt sırasında olsa da görünür bantta kalır; bu yüzden eksik bir kanaldan çok, kararda en son başvurulan ölçüt gibi çalışır.`
        : `${profile.lowest.key} at ${profile.lowest.value}% is last in order but still in the visible band, so it acts as the last criterion consulted rather than a missing channel.`);

  const destekCumle = profile.support.value >= 50
    ? (lang === "tr"
        ? `${profile.support.key} ${profile.support.value}% düzeyi karara ${STYLE_CONTENT.tr[profile.support.key].core.toLocaleLowerCase("tr-TR")} açısından ikinci bir kontrol ekler.`
        : `${profile.support.key} at ${profile.support.value}% adds a second check through ${STYLE_CONTENT.en[profile.support.key].core}.`)
    : (lang === "tr"
        ? `${profile.support.key} ${profile.support.value}% ana stil eşiğinin altındadır; kararda ikinci bir kontrol olarak ancak bilinçli çağrıldığında devreye girer.`
        : `${profile.support.key} at ${profile.support.value}% is below the lead threshold and only acts as a second check when deliberately invoked.`);

  const soru = buildDecisionQuestion(profile.lowest.key, lang);
  // Liderin YÜKSEKLİĞİ karar hızını da belirler: %95 ile %55 aynı cümleyi almamalı.
  const kararSiddeti = ["veryHigh", "high"].includes(getScoreLevel(profile.lead.value))
    ? (lang === "tr"
        ? `Bu eğilim ${profile.lead.value}% düzeyinde olduğu için karar anında baskın çıkar. `
        : `At ${profile.lead.value}% this tendency dominates the moment of decision. `)
    : (lang === "tr"
        ? `Bu eğilim ${profile.lead.value}% ile eşiğin hemen üzerinde olduğundan karar anında baskın çıkmayabilir; bağlam ağır basarsa ikinci kanal öne geçer. `
        : `At ${profile.lead.value}% the tendency sits just above the threshold and may not dominate; under contextual pressure the second channel can take over. `);
  return lang === "tr"
    ? `${STYLE_CONTENT.tr[profile.lead.key].decision} ${kararSiddeti}${destekCumle} ${enDusukCumle} Kapanıştan önce sorulacak kontrol sorusu: “${soru}”`
    : `${STYLE_CONTENT.en[profile.lead.key].decision} ${kararSiddeti}${destekCumle} ${enDusukCumle} Control question before closure: “${soru}”`;
}

function buildAdaptationInsight(differences, profile, lang) {
  const close = differences.filter((item) => item.distance.key === "close");
  const far = differences.filter((item) => item.distance.key === "far");
  const veryFar = differences.filter((item) => item.distance.key === "veryFar");
  const sentences = [];

  if (close.length === 4) {
    const leadRow = differences.find((item) => item.key === profile.lead.key);
    const supportRow = differences.find((item) => item.key === profile.support.key);
    sentences.push(lang === "tr"
      ? `Dört boyutun tamamı ±15 puan içinde; profil genel olarak doğal hale yakındır. Özellikle lider ${profile.lead.key}, doğal ${leadRow.natural}% düzeyinden uyarlanmış ${leadRow.adapted}% düzeyine ${formatDelta(leadRow.delta)} puanla gelir. Bu, ${PROFILE_TITLES.tr[profile.lead.key].toLocaleLowerCase("tr-TR")} davranışının yalnız mevcut rol için takılmış geçici bir görünümden çok, temel eğilimle uyumlu çalıştığını düşündürür. ${profile.support.key} desteği ${supportRow.delta === 0 ? "aynı düzeyde kalır" : `${formatDelta(supportRow.delta)} puan ${supportRow.delta > 0 ? "daha görünür" : "daha ölçülü"} kullanılır`}.`
      : `All four dimensions are within ±15 points. The lead ${profile.lead.key} moves from ${leadRow.natural}% naturally to ${leadRow.adapted}% currently, a ${formatDelta(leadRow.delta)}-point shift, suggesting the lead behaviour is aligned with foundational preference rather than merely a temporary role mask.`);
  } else if (close.length) {
    sentences.push(lang === "tr"
      ? `${joinKeys(close.map((item) => item.key), lang)} ±15 puan içinde ve doğal hale yakındır.`
      : `${joinKeys(close.map((item) => item.key), lang)} are within ±15 points and close to the natural state.`);
  }
  if (far.length) {
    sentences.push(lang === "tr"
      ? `${joinKeys(far.map((item) => item.key), lang)} 16-30 puan aralığında doğal halden uzaktır; bu alanlarda mevcut bağlam belirgin bir davranış ayarı istiyor olabilir.`
      : `${joinKeys(far.map((item) => item.key), lang)} are 16-30 points from the natural state, suggesting visible contextual adjustment.`);
  }
  if (veryFar.length) {
    sentences.push(lang === "tr"
      ? `${joinKeys(veryFar.map((item) => item.key), lang)} 30 puandan fazla ayrışır ve doğal halden çok uzaktır; bunun rol gereği, geçici koşul veya uzun süren enerji maliyeti olup olmadığı görüşmede araştırılmalıdır.`
      : `${joinKeys(veryFar.map((item) => item.key), lang)} differ by more than 30 points and are very far from the natural state; explore whether this reflects role demand, temporary context or sustained energy cost.`);
  }
  sentences.push(lang === "tr"
    ? `${buildLargestDifferenceText(differences, lang)} Artı fark daha görünür, eksi fark daha ölçülü kullanım demektir; yön tek başına iyi veya kötü değildir.`
    : `${buildLargestDifferenceText(differences, lang)} Positive means more visible and negative more moderated; direction is not inherently good or bad.`);
  return sentences.join(" ");
}

function buildStrengths(profile, lang) {
  if (!profile.active.length) {
    return [lang === "tr"
      ? "Bağlama göre davranış seçebilme ve tek bir kalıba yaslanmama potansiyeli"
      : "Potential to select behaviour by context without relying on one default pattern"];
  }
  const items = [
    lang === "tr"
      ? `${profile.lead.key} ${profile.lead.value}% - ${STYLE_CONTENT.tr[profile.lead.key].contribution}; ${getScoreBand(profile.lead.value, lang).label.toLocaleLowerCase("tr-TR")} görünürlük nedeniyle bu katkı başkaları tarafından kolay fark edilir.`
      : `${profile.lead.key} ${profile.lead.value}% - ${STYLE_CONTENT.en[profile.lead.key].contribution}; its ${getScoreBand(profile.lead.value, lang).label.toLowerCase()} visibility makes this contribution easy to notice.`,
    // ONARIM: %10'luk bir kanalın o katkıyı "getirdiği" iddia ediliyordu.
    ["low", "veryLow"].includes(getScoreLevel(profile.support.value))
      ? (lang === "tr"
          ? `${profile.support.key} ${profile.support.value}% - Sırada ikinci olsa da düşük bantta olduğu için bugün bir güç değil, ${STYLE_CONTENT.tr[profile.support.key].contribution.toLocaleLowerCase("tr-TR")} yönünde açık bir gelişim alanıdır.`
          : `${profile.support.key} ${profile.support.value}% - Second in order but in the low band, so today it is a development area rather than a strength.`)
      : (lang === "tr"
          ? `${profile.support.key} ${profile.support.value}% - ${profile.support.value >= 50 ? "İkinci ana kanal olarak" : "Eşik altındaki en yakın destek olarak"} ${STYLE_CONTENT.tr[profile.support.key].contribution.toLocaleLowerCase("tr-TR")} getirir.`
          : `${profile.support.key} ${profile.support.value}% - ${STYLE_CONTENT.en[profile.support.key].contribution} as the closest support channel.`),
    // ONARIM: leadGap 0 iken "önce lider, sonra destek" sırası kurulamaz.
    profile.leadGap === 0
      ? (lang === "tr"
          ? `${profile.lead.key} ve ${profile.support.key} aynı düzeyde - hangisinin öne çıkacağı kişiye değil duruma bağlıdır; bu, sıralı bir geçiş değil, seçime açık iki eşit kanaldır.`
          : `${profile.lead.key} and ${profile.support.key} are level - which one leads depends on the situation, so these are two equal channels rather than a sequence.`)
      : (lang === "tr"
          ? `${profile.lead.key}-${profile.support.key} geçişi - ${profile.leadGap} puanlık fark, kişinin önce ${profile.lead.key} ile başlayıp ihtiyaç olduğunda ${profile.support.key} kaynağına geçme olasılığını gösterir.`
          : `${profile.lead.key}-${profile.support.key} transition - the ${profile.leadGap}-point gap suggests starting with ${profile.lead.key} and moving to ${profile.support.key} when needed.`)
  ];
  // Örüntü katkısı: klasik örüntü güçlü yanı, biçim yeterince belirginse eklenir.
  if (!profile.oruntu.duz) {
    items.push(lang === "tr"
      ? `${profile.oruntu.ad} örüntüsü - ${profile.oruntu.guc}`
      : `${profile.oruntu.ad} pattern - ${profile.oruntu.guc}`);
  }
  return items;
}

function buildWatchouts(profile, adaptedSorted, lang) {
  const items = adaptedSorted
    .filter((item) => getScoreLevel(item.value) === "veryHigh")
    .map((item) => `${item.key} ${item.value}% - ${STYLE_CONTENT[lang][item.key].excess}`);
  adaptedSorted
    .filter((item) => ["low", "veryLow"].includes(getScoreLevel(item.value)))
    .forEach((item) => items.push(`${item.key} ${item.value}% - ${STYLE_CONTENT[lang][item.key].underuse}`));
  if (!items.length) {
    items.push(lang === "tr"
      ? "Aşırı veya çok düşük bir sinyal görünmüyor; dikkat noktası, hangi davranışın hangi koşulda bilinçli öne alınacağıdır."
      : "No extreme or very low signal is visible; the watch-out is choosing deliberately which behaviour should lead in each context.");
  }
  // ONARIM: yayılım 0 iken "en az görünür kanal" diye bir kanal YOKTUR; dördü eşittir.
  if (profile.spread > 0 && !items.some((item) => item.startsWith(`${profile.lowest.key} `))) {
    items.push(lang === "tr"
      ? `${profile.lowest.key} ${profile.lowest.value}% - Profilin en az görünür kanalıdır. ${STYLE_CONTENT.tr[profile.lowest.key].underuse}`
      : `${profile.lowest.key} ${profile.lowest.value}% - This is the least visible channel. ${STYLE_CONTENT.en[profile.lowest.key].underuse}`);
  }
  // ONARIM: 0 puanlık açıklıktan kör nokta çıkarılamaz.
  items.push(profile.spread === 0
    ? (lang === "tr"
        ? "Dört kanal aynı düzeyde olduğu için lider-en düşük açıklığından doğan bir kör nokta yoktur; asıl risk, baskı altında hangi davranışın öne alınacağının belirsiz kalmasıdır."
        : "With all four channels level there is no lead-to-lowest blind spot; the real risk is that under pressure it stays unclear which behaviour should lead.")
    : (lang === "tr"
        ? `${profile.lead.key}-${profile.lowest.key} açıklığı ${profile.spread} puandır; baskı altında ${profile.lead.key} davranışı güçlenirken ${profile.lowest.key} ihtiyacının gözden kaçması temel kör nokta olabilir.`
        : `The ${profile.lead.key}-${profile.lowest.key} spread is ${profile.spread} points; under pressure the lead may intensify while the lowest-channel need is missed.`));
  // Örüntü gerilimi: klasik örüntünün kendi risk alanı.
  if (!profile.oruntu.duz) {
    items.push(lang === "tr"
      ? `${profile.oruntu.ad} örüntüsünün gerilimi - ${profile.oruntu.gerilim}`
      : `${profile.oruntu.ad} pattern tension - ${profile.oruntu.gerilim}`);
  }
  if (profile.hasNearCluster) {
    items.push(lang === "tr"
      ? "Yakın küme esneklik sağlar; karar anında hangi sinyalin lider olduğu karşı tarafa görünür kılınmalıdır."
      : "The near cluster offers flexibility; make the leading signal visible to others when a decision is required.");
  }
  return items;
}

function buildSelfCommunicationTips(profile, lang) {
  if (!profile.active.length) {
    return [
      lang === "tr" ? "Konuşmaya başlamadan önce amacın hız, katılım, güvence veya doğruluk olup olmadığını seçin." : "Before speaking, choose whether the purpose is speed, participation, reassurance or accuracy.",
      lang === "tr" ? "Karşı tarafın ihtiyacını gözlemleyip mesajın tonunu ve ayrıntı düzeyini ona göre ayarlayın." : "Observe the other person’s need and adjust tone and detail accordingly."
    ];
  }
  const lead = profile.active[0].key;
  const second = profile.support.key;
  return [
    lang === "tr"
      ? `${lead} ${profile.lead.value}% mesajınızın ilk tonunu belirler: ${STYLE_SCENARIOS.tr[lead].feedback}`
      : `${lead} ${profile.lead.value}% sets the first tone: ${STYLE_SCENARIOS.en[lead].feedback}`,
    lang === "tr"
      ? `${second} ${profile.support.value}% kanalını ${lead} etkisini dengelemek için kullanın; ${STYLE_CONTENT.tr[second].contribution.toLocaleLowerCase("tr-TR")} mesajın ikinci katmanı olsun.`
      : `Use ${second} ${profile.support.value}% to balance ${lead} through ${STYLE_CONTENT.en[second].contribution.toLowerCase()}.`,
    lang === "tr"
      ? `${profile.lowest.key} ${profile.lowest.value}% nedeniyle mesajı göndermeden önce şu kontrolü yapın: ${buildDecisionQuestion(profile.lowest.key, lang)}`
      : `Because ${profile.lowest.key} is lowest at ${profile.lowest.value}%, check: ${buildDecisionQuestion(profile.lowest.key, lang)}`,
    lang === "tr"
      ? `Profilinizde lider ile destek arasındaki fark ${profile.leadGap} puan; karşı taraf ilk ${lead} tonunu güçlü algılarsa ${second} kanalını görünür biçimde adlandırın.`
      : `The lead-support gap is ${profile.leadGap} points; if others feel the ${lead} tone strongly, make the ${second} channel explicit.`
  ];
}

function buildCommunicationGuide(profile, lang) {
  const sourceKeys = profile.lead ? [profile.lead.key, profile.support.key] : [];
  const activeSignature = profile.active.length
    ? profile.active.map((item) => `${item.key}${item.value}`).join(" > ")
    : (lang === "tr" ? "%50 üzeri ana stil yok" : "no 50+ lead style");
  return DISC_LABELS.map((target) => {
    const base = TARGET_GUIDANCE[lang][target];
    const adjustments = sourceKeys.map((source) => SOURCE_TO_TARGET[lang][source][target]);
    return {
      key: target,
      ...base,
      personalised: adjustments.length
        ? (lang === "tr"
            ? `Ana stil sıranız ${activeSignature}. ${profile.lead.key} ${profile.lead.value}% ilk tonunuz, ${profile.support.key} ${profile.support.value}% ise destek kanalınızdır. ${adjustments.join(" ")} ${profile.lowest.key} ${profile.lowest.value}% en az görünür alanınız olduğu için ${buildTargetCheck(target, profile.lowest.key, lang)}`
            : `Your active order is ${activeSignature}. ${profile.lead.key} ${profile.lead.value}% is your first tone and ${profile.support.key} ${profile.support.value}% your support channel. ${adjustments.join(" ")} ${buildTargetCheck(target, profile.lowest.key, lang)}`)
        : (lang === "tr"
            ? "Belirgin bir ana stil olmadığı için bu kişinin hedef stile göre tonu, tempoyu ve ayrıntıyı bilinçli seçmesi özellikle önemlidir."
            : "With no clear lead style, deliberately selecting tone, pace and detail for the target style is especially important.")
    };
  });
}

function buildManagerNotes(profile, differences, participant, lang) {
  const notes = [];
  if (profile.active.length) {
    notes.push(lang === "tr"
      ? `${profile.lead.key} ${profile.lead.value}% için: ${STYLE_SCENARIOS.tr[profile.lead.key].manager}`
      : `For ${profile.lead.key} ${profile.lead.value}%: ${STYLE_SCENARIOS.en[profile.lead.key].manager}`);
    notes.push(lang === "tr"
      ? `${profile.support.key} ${profile.support.value}% desteğini kullanmak için: ${STYLE_SCENARIOS.tr[profile.support.key].delegation}`
      : `To use the ${profile.support.key} ${profile.support.value}% support channel: ${STYLE_SCENARIOS.en[profile.support.key].delegation}`);
    notes.push(lang === "tr"
      ? `${profile.lowest.key} ${profile.lowest.value}% kör noktasını dengelemek için yöneticinin kontrol sorusu şu olmalı: ${buildDecisionQuestion(profile.lowest.key, lang)}`
      : `To balance the lowest ${profile.lowest.key} ${profile.lowest.value}% channel, ask: ${buildDecisionQuestion(profile.lowest.key, lang)}`);
  } else {
    notes.push(lang === "tr"
      ? "Varsayılan bir tarz beklemek yerine rolün hangi davranışı ne zaman istediğini açıkça belirtin."
      : "Rather than assuming a default style, state which behaviour the role needs and when.");
  }
  const distant = differences.filter((item) => item.distance.key !== "close");
  if (distant.length) {
    notes.push(lang === "tr"
      ? `${joinKeys(distant.map((item) => item.key), lang)} alanındaki uyarlamanın geçici mi kalıcı mı olduğunu düzenli bire bir görüşmelerde araştırın.`
      : `Use regular one-to-ones to explore whether adaptation in ${joinKeys(distant.map((item) => item.key), lang)} is temporary or sustained.`);
  }
  const rolePhrase = buildRolePhrase(participant?.roleLevel, lang);
  if (rolePhrase) notes.push(rolePhrase);
  return notes;
}

function buildHrNotes(profile, lang) {
  const code = profile.active.map((item) => item.key).join("-") || (lang === "tr" ? "eşik altı" : "sub-threshold");
  return [
    lang === "tr"
      ? `${code} örüntüsünü koçluk, takım iletişimi ve gelişim görüşmelerinde hipotez olarak kullanın; hüküm olarak değil.`
      : `Use the ${code} pattern as a coaching and team-development hypothesis, not a verdict.`,
    lang === "tr"
      ? "Rapor yetenek, zekâ, değerler, ruh sağlığı veya tek başına iş başarısı ölçümü değildir."
      : "The report does not measure ability, intelligence, values, mental health or standalone job success.",
    lang === "tr"
      ? "İşe alım, terfi veya performans kararını yalnız bu rapora dayandırmayın; yapılandırılmış görüşme ve işle ilgili kanıtlarla birlikte değerlendirin."
      : "Do not base hiring, promotion or performance decisions on this report alone; combine it with structured interviews and job-relevant evidence."
  ];
}

function buildDevelopmentPlan(profile, differences, lang) {
  const lead = profile.active[0]?.key;
  const rankedDifferences = [...differences].sort((a, b) => b.distance.distance - a.distance.distance);
  const distant = rankedDifferences[0];
  const equallyDistant = rankedDifferences.filter((item) => item.distance.distance === distant.distance.distance);
  const allClose = rankedDifferences.every((item) => item.distance.key === "close");
  const opposite = { D: "S", I: "C", S: "D", C: "I" }[profile.lead.key];
  const activeSignature = profile.active.length
    ? profile.active.map((item) => `${item.key}${item.value}`).join(" > ")
    : (lang === "tr" ? "%50 üzeri ana stil yok" : "no 50+ lead style");
  return [
    lead
      ? (lang === "tr" ? `1. Hafta: ${STYLE_SCENARIOS.tr[lead].experiment}` : `Week 1: ${STYLE_SCENARIOS.en[lead].experiment}`)
      : (lang === "tr" ? "1. Hafta: Farklı iş durumlarında hangi davranış kanalını seçtiğinizi kaydedin." : "Week 1: Record which behavioural channel you choose in different work situations."),
    lang === "tr"
      ? `2. Hafta: En düşük ${profile.lowest.key} ${profile.lowest.value}% kanalını bilinçli çalıştırın: ${buildLowChannelExercise(profile.lowest.key, lang)}`
      : `Week 2: Deliberately exercise the lowest ${profile.lowest.key} ${profile.lowest.value}% channel: ${buildLowChannelExercise(profile.lowest.key, lang)}`,
    allClose
      ? (lang === "tr"
          ? `3. Hafta: Tüm farklar ±15 içinde olduğu için rol maskesi aramak yerine enerji kullanımını test edin. ${profile.lead.key} davranışını yoğun kullandığınız üç günün sonunda eforunuzu 1-5 puanlayın; yüksek efor varsa ${profile.support.key} kanalının dengeleyici etkisini deneyin.`
          : `Week 3: Since all differences are within ±15, test energy rather than role strain. Rate effort after three high-${profile.lead.key} days and use ${profile.support.key} as a balancing channel.`)
      : (lang === "tr"
          ? `3. Hafta: ${equallyDistant.length > 1 ? `En büyük uyarlanmalar ${joinKeys(equallyDistant.map((item) => item.key), lang)} alanlarında eşit büyüklüktedir (${equallyDistant.map((item) => `${item.key} ${formatDelta(item.delta)}`).join(", ")}).` : `En büyük uyarlanma ${distant.key} alanında ${formatDelta(distant.delta)} puandır.`} Bunun hangi görev, kişi veya beklentiyle tetiklendiğini üç gerçek olay üzerinden ayırın.`
          : `Week 3: ${equallyDistant.length > 1 ? `The largest adaptations are tied across ${joinKeys(equallyDistant.map((item) => item.key), lang)}.` : `The largest adaptation is ${formatDelta(distant.delta)} in ${distant.key}.`} Identify the triggering task, person or expectation across three real events.`),
    lang === "tr"
      ? `4. Hafta: Ana sıranız ${activeSignature}. ${opposite} ağırlıklı biriyle önemli bir görüşme yapın; ilk tonunuzu korurken karşı taraf için yaptığınız tempo, ayrıntı ve ilişki ayarını yazın.`
      : `Week 4: Your active order is ${activeSignature}. Hold an important conversation with a ${opposite}-leaning person and record how you adjusted pace, detail and relationship.`
  ];
}

function buildProfileArchitecture(profile, differences, lang) {
  const leadBand = getScoreBand(profile.lead.value, lang);
  const supportBand = getScoreBand(profile.support.value, lang);
  const leadDifference = differences.find((item) => item.key === profile.lead.key);
  const supportStatus = profile.support.value >= 50
    ? (lang === "tr" ? "ana konuşulan ikinci stil" : "second active lead style")
    : (lang === "tr" ? "eşik altındaki en yakın tamamlayıcı" : "closest sub-threshold support");

  return [
    {
      key: "lead",
      title: lang === "tr" ? "İlk refleks" : "First impulse",
      body: lang === "tr"
        ? `${profile.lead.key} ${profile.lead.value}% (${leadBand.label.toLocaleLowerCase("tr-TR")}) profilin ilk refleksidir. ${STYLE_SCENARIOS.tr[profile.lead.key].portrait}`
        : `${profile.lead.key} ${profile.lead.value}% (${leadBand.label.toLowerCase()}) is the first impulse. ${STYLE_SCENARIOS.en[profile.lead.key].portrait}`
    },
    {
      key: "support",
      title: lang === "tr" ? "Destek kanalı" : "Support channel",
      body: lang === "tr"
        ? `${profile.support.key} ${profile.support.value}% (${supportBand.label.toLocaleLowerCase("tr-TR")}) ${supportStatus}. Lider stile ${STYLE_CONTENT.tr[profile.support.key].contribution.toLocaleLowerCase("tr-TR")} ekler.`
        : `${profile.support.key} ${profile.support.value}% (${supportBand.label.toLowerCase()}) is the ${supportStatus} and adds ${STYLE_CONTENT.en[profile.support.key].contribution.toLowerCase()}.`
    },
    {
      key: "shape",
      title: lang === "tr" ? "Profil geometrisi" : "Profile geometry",
      body: lang === "tr"
        ? `Lider ile destek arasında ${profile.leadGap}, lider ile en düşük ${profile.lowest.key} arasında ${profile.spread} puan vardır. Bu sayısal açıklık ${profile.shape.toLocaleLowerCase("tr-TR")} bir profil üretir.`
        : `The lead-support gap is ${profile.leadGap} points and the lead-lowest spread is ${profile.spread}, producing a ${profile.shape.toLowerCase()} profile.`
    },
    {
      key: "alignment",
      title: lang === "tr" ? "Doğal uyum" : "Natural alignment",
      body: lang === "tr"
        ? `${profile.lead.key} doğal ${leadDifference.natural}%, uyarlanmış ${leadDifference.adapted}% ve fark ${formatDelta(leadDifference.delta)} puandır. ${buildLargestDifferenceText(differences, lang)}`
        : `${profile.lead.key} is ${leadDifference.natural}% naturally and ${leadDifference.adapted}% adapted, a ${formatDelta(leadDifference.delta)}-point shift. ${buildLargestDifferenceText(differences, lang)}`
    }
  ];
}

function buildScenarioReadings(profile, lang) {
  const lead = profile.lead.key;
  const support = profile.support.key;
  const lowest = profile.lowest.key;
  const leadScenario = STYLE_SCENARIOS[lang][lead];
  const supportContent = STYLE_CONTENT[lang][support];
  const lowestContent = STYLE_CONTENT[lang][lowest];
  const supportLabel = profile.support.value >= 50
    ? (lang === "tr" ? "ikinci aktif stil" : "second active style")
      : (lang === "tr" ? "eşik altı destek" : "sub-threshold support");
  const activeSignature = profile.active.length
    ? profile.active.map((item) => `${item.key}${item.value}`).join(" > ")
    : (lang === "tr" ? "%50 üzeri ana stil yok" : "no 50+ lead style");

  if (lang === "tr") {
    return [
      {
        key: "meeting",
        title: "Toplantıda",
        text: `${leadScenario.meeting} ${support} ${profile.support.value}% ${supportLabel} olarak ${supportContent.contribution.toLocaleLowerCase("tr-TR")} getirir.`,
        focus: `Ana sıra ${activeSignature}. ${lowest} ${profile.lowest.value}% kontrolü: ${buildDecisionQuestion(lowest, lang)}`
      },
      {
        key: "decision",
        title: "Karar Alırken",
        text: `${STYLE_CONTENT.tr[lead].decision} ${support} kanalı ${supportContent.decision.toLocaleLowerCase("tr-TR")}`,
        focus: `Kapanış sorusu: ${buildDecisionQuestion(lowest, lang)}`
      },
      {
        key: "conflict",
        title: "Çatışmada",
        text: `${leadScenario.conflict} ${support} desteği ${supportContent.core.toLocaleLowerCase("tr-TR")} ihtiyacını masada tutabilir.`,
        focus: `${lowest} ${profile.lowest.value}% alanı: ${lowestContent.underuse}`
      },
      {
        key: "change",
        title: "Değişimde",
        text: `${leadScenario.change} ${support} ${profile.support.value}% düzeyi değişime ${supportContent.core.toLocaleLowerCase("tr-TR")} merceğini ekler.`,
        focus: `Profilin değişim mesajı önce ${lead}, sonra ${support} dilinde kurulmalıdır.`
      },
      {
        key: "pressure",
        title: "Baskı Altında",
        text: `${leadScenario.pressure} Lider ile en düşük kanal arasındaki ${profile.spread} puanlık açıklık bu etkiyi belirginleştirebilir.`,
        focus: `${lowest} denge kanalı için: ${buildDecisionQuestion(lowest, lang)}`
      },
      {
        key: "feedback",
        title: "Geri Bildirimde",
        text: `${leadScenario.feedback} ${support} desteği geri bildirime ${supportContent.contribution.toLocaleLowerCase("tr-TR")} boyutu ekler.`,
        focus: `Yönetici yaklaşımı: ${leadScenario.manager}`
      }
    ];
  }

  return [
    { key: "meeting", title: "In Meetings", text: `${leadScenario.meeting} ${support} ${profile.support.value}% adds ${supportContent.contribution.toLowerCase()}.`, focus: `Active order ${activeSignature}. ${lowest} check: ${buildDecisionQuestion(lowest, lang)}` },
    { key: "decision", title: "When Deciding", text: `${STYLE_CONTENT.en[lead].decision} ${supportContent.decision}`, focus: `Closing question: ${buildDecisionQuestion(lowest, lang)}` },
    { key: "conflict", title: "In Conflict", text: `${leadScenario.conflict} ${support} can keep ${supportContent.core} in view.`, focus: `${lowest}: ${lowestContent.underuse}` },
    { key: "change", title: "During Change", text: `${leadScenario.change} ${support} adds ${supportContent.core}.`, focus: `Build the message first in ${lead}, then ${support} language.` },
    { key: "pressure", title: "Under Pressure", text: `${leadScenario.pressure} The ${profile.spread}-point spread may intensify this.`, focus: `${lowest} check: ${buildDecisionQuestion(lowest, lang)}` },
    { key: "feedback", title: "With Feedback", text: `${leadScenario.feedback} ${support} adds ${supportContent.contribution.toLowerCase()}.`, focus: `Manager approach: ${leadScenario.manager}` }
  ];
}

function getProfileShape(active, lead, support, lang) {
  const gap = Math.max(0, (lead?.value || 0) - (support?.value || 0));
  if (!active.length) {
    return lang === "tr" ? "Bağlama göre seçici" : "Context-selective";
  }
  if (active.length === 1) {
    if (gap >= 30) return lang === "tr" ? "Keskin tek odak" : "Sharp single focus";
    if (gap >= 15) return lang === "tr" ? "Belirgin tek odak" : "Pronounced single focus";
    return lang === "tr" ? "Tek ana stil, yakın destek" : "Single lead with close support";
  }
  if (active[0].value === active[1].value) return lang === "tr" ? "Eş liderli çok kanallı" : "Multi-channel co-lead";
  if (gap <= 5) return lang === "tr" ? "Yakın kümeli çok kanallı" : "Near-cluster multi-channel";
  return lang === "tr" ? "Katmanlı çok kanallı" : "Layered multi-channel";
}

function buildDecisionQuestion(key, lang) {
  const questions = {
    tr: {
      D: "Karar, sahiplik ve sınır yeterince açık mı?",
      I: "İnsanları dahil ettim ve fikrin anlamını görünür kıldım mı?",
      S: "İnsan etkisini, desteği ve sürdürülebilir tempoyu hesaba kattım mı?",
      C: "Kanıt, risk ve kalite ölçütü karar için yeterince açık mı?"
    },
    en: {
      D: "Are the decision, ownership and boundary clear enough?",
      I: "Have I involved people and made the meaning visible?",
      S: "Have I considered human impact, support and sustainable pace?",
      C: "Are evidence, risk and quality criteria clear enough?"
    }
  };
  return questions[lang][key];
}

function buildLargestDifferenceText(differences, lang) {
  const maxDistance = Math.max(...differences.map((item) => item.distance.distance));
  const largest = differences.filter((item) => item.distance.distance === maxDistance);
  if (largest.length > 1) {
    const keys = joinKeys(largest.map((item) => item.key), lang);
    return lang === "tr"
      ? `En büyük mutlak hareket ${keys} alanlarında eşit olarak ${maxDistance} puandır; tek bir boyutu yapay biçimde öne çıkarmak doğru değildir.`
      : `The largest absolute movement is tied across ${keys} at ${maxDistance} points; no single dimension should be selected artificially.`;
  }
  const item = largest[0];
  return lang === "tr"
    ? `En büyük mutlak hareket ${item.key} alanında ${formatDelta(item.delta)} puandır ve ${item.distance.label.toLocaleLowerCase("tr-TR")}.`
    : `The largest absolute movement is ${formatDelta(item.delta)} points in ${item.key} and is ${item.distance.label.toLowerCase()}.`;
}

function buildTargetCheck(target, lowest, lang) {
  if (lang === "tr") {
    return `${target} tarzındaki kişiye giderken en düşük ${lowest} kanalınızı bilinçli kontrol edin: ${buildDecisionQuestion(lowest, lang)}`;
  }
  return `When approaching a ${target} person, deliberately check the lowest ${lowest} channel: ${buildDecisionQuestion(lowest, lang)}`;
}

function buildLowChannelExercise(key, lang) {
  const exercises = {
    tr: {
      D: "Ertelediğiniz bir zor konuşmayı talep, sınır ve tarih içeren üç net cümleyle yapın.",
      I: "Bir fikri 90 saniyelik örnek ve görünür faydayla anlatın; karşı taraftan bir tepki isteyin.",
      S: "Bir iş için haftalık takip ritmi kurun ve değişimin insan etkisini açıkça sorun.",
      C: "Tekrarlanan bir iş için üç maddelik ölçüt ve kontrol listesi oluşturun."
    },
    en: {
      D: "Hold one delayed difficult conversation using three clear sentences: ask, boundary and date.",
      I: "Present one idea through a 90-second example and visible benefit, then ask for a response.",
      S: "Create a weekly follow-through rhythm and ask explicitly about the human impact of change.",
      C: "Create a three-item criterion and checklist for one repeated task."
    }
  };
  return exercises[lang][key];
}

function buildRolePhrase(roleLevel, lang) {
  const roles = {
    tr: {
      executive: "Üst yönetim rolünde bu örüntünün kurum çapındaki hız, katılım ve karar kalitesi üzerindeki etkisi özellikle görünür olacaktır.",
      director: "Fonksiyon liderliği rolünde bu örüntüyü farklı uzmanlıkları ortak karar dilinde buluşturmak için bilinçli kullanın.",
      manager: "Müdür rolünde profilin etkisi yalnız kişisel üretimde değil, ekibin karar temposu ve psikolojik alanında da görülecektir.",
      team_leader: "Takım liderliği rolünde günlük tonunuz ekip tarafından çalışma standardı olarak okunabilir; ilk refleksinizin etkisini düzenli kontrol edin.",
      specialist: "Bireysel katkı rolünde bu örüntünün uzmanlık görünürlüğü, paydaş etkisi ve iş takibi üzerindeki karşılığını birlikte değerlendirin.",
      operations: "Operasyon ve saha bağlamında hız, devir teslim, standart ve insan etkisi arasındaki dengeyi gerçek olaylarla doğrulayın.",
      student: "Öğrencilikte bu örüntü henüz bir iş rolüyle değil; takım projeleri, staj ve ders çalışmalarıyla sınanır. Güçlü yanınızı erken fark etmek, kariyer başlangıcında hangi ortamda daha hızlı geliştiğinizi seçmenizi kolaylaştırır.",
      other: "Rol bağlamı özel olduğu için yorumu gerçek sorumluluklar ve kritik iş olaylarıyla doğrulayın."
    },
    en: {
      executive: "In an executive role, this pattern will be especially visible in organisation-wide pace, participation and decision quality.",
      director: "In functional leadership, use the pattern deliberately to bring different expertise into a shared decision language.",
      manager: "In a manager role, the pattern affects not only personal output but also team pace and psychological space.",
      team_leader: "In team leadership, daily tone may be read as a working standard; review the effect of the first impulse.",
      specialist: "As an individual contributor, examine expertise visibility, stakeholder influence and follow-through together.",
      operations: "In operations, validate the balance of pace, handover, standard and human impact through real events.",
      student: "As a student, this pattern is tested through team projects, internships and coursework rather than a job role. Recognising it early helps you choose the environments where you develop fastest at the start of your career.",
      other: "Validate this reading against real responsibilities and critical work events."
    }
  };
  return roles[lang][roleLevel] || "";
}

function buildDimensionSection(key, adapted, natural, delta, lang, profile) {
  const adaptedBand = getScoreBand(adapted, lang);
  const naturalBand = getScoreBand(natural, lang);
  const distance = getDifferenceBand(delta, lang);
  const style = STYLE_CONTENT[lang][key];
  const relativeRole = key === profile.lead.key
    ? (lang === "tr" ? "Bu boyut profilin ilk refleksini ve dışarıdan en kolay görülen davranışını taşır." : "This dimension carries the first impulse and most visible behaviour.")
    : key === profile.support.key
      ? (lang === "tr" ? `Bu boyut ${profile.lead.key} liderliğine en yakın destek kanalıdır; aradaki fark ${profile.leadGap} puandır.` : `This is the closest support channel to ${profile.lead.key}, ${profile.leadGap} points behind.`)
      : key === profile.lowest.key
        ? (lang === "tr" ? `Bu boyut profilin en az görünür kanalıdır ve ${profile.lead.key} davranışının kör noktasını dengeleyebilir.` : `This is the least visible channel and can balance the ${profile.lead.key} blind spot.`)
        : (lang === "tr" ? "Bu boyut ana anlatıyı kurmaz; belirli koşullarda devreye giren durumsal bir kaynaktır." : "This does not define the main narrative; it is a situational resource.");
  return {
    key,
    adapted,
    natural,
    delta,
    level: adaptedBand.key,
    adaptedBand,
    naturalBand,
    distance,
    content: {
      title: KLASIK_BOYUT_ADI[lang][key],   // başlık: klasik boyut adı
      styleName: getDiscName(key, lang),    // altında: Someren stil adı
      headline: lang === "tr"
        ? `${key}, uyarlanmış profilde ${adaptedBand.label.toLocaleLowerCase("tr-TR")} düzeydedir (${adapted}%).`
        : `${key} is ${adaptedBand.label.toLowerCase()} in the adapted profile (${adapted}%).`,
      interpretation: adapted >= 50
        ? (lang === "tr" ? `${style.work} Bu sinyal mevcut profilin ana konuşulan davranışları arasındadır. ${relativeRole}` : `${style.work} This signal is one of the active behaviours. ${relativeRole}`)
        : (lang === "tr" ? `${style.underuse} Ana stil olarak değil, tamamlayıcı veya durumsal bir kaynak olarak okunur. ${relativeRole}` : `${style.underuse} Read it as complementary or situational. ${relativeRole}`),
      natural: lang === "tr"
        ? `Doğal düzey ${natural}% (${naturalBand.label.toLocaleLowerCase("tr-TR")}); temel eğilimde ${style.core} ihtiyacının görünürlüğünü anlatır.`
        : `Natural level is ${natural}% (${naturalBand.label.toLowerCase()}); it describes the visibility of ${style.core} in foundational preference.`,
      delta: buildDeltaSentence(key, delta, distance, lang)
    }
  };
}

function buildDifferenceRow(key, adapted, natural, delta, lang) {
  const distance = getDifferenceBand(delta, lang);
  return { key, adapted, natural, delta, distance, text: buildDeltaSentence(key, delta, distance, lang) };
}

function buildDeltaSentence(key, delta, distance, lang) {
  if (delta === 0) {
    return lang === "tr"
      ? `${key} değişmiyor; doğal ve uyarlanmış skor aynıdır. ${distance.label}.`
      : `${key} is unchanged; natural and adapted scores are equal. ${distance.label}.`;
  }
  const direction = delta > 0
    ? (lang === "tr" ? "daha görünür kullanılıyor" : "is used more visibly")
    : (lang === "tr" ? "daha ölçülü kullanılıyor" : "is used more selectively");
  return lang === "tr"
    ? `${key} uyarlanmış profilde ${formatDelta(delta)} puanla ${direction}. ${distance.label}; bu yön tek başına olumlu veya olumsuz değildir.`
    : `${key} ${direction} in the adapted profile by ${formatDelta(delta)} points. ${distance.label}; the direction is not inherently positive or negative.`;
}

function buildMethodology(lang) {
  return {
    activeRule: lang === "tr"
      ? "Uyarlanmış profilde yalnız %50 ve üzerindeki sinyaller ana konuşulan stil kabul edilir; daha yüksek skor önce gelir."
      : "Only adapted signals at 50% or above are treated as active lead styles, ordered from higher to lower.",
    clusterRule: lang === "tr"
      ? "En yüksek skorla arasında en fazla 5 puan bulunan aktif sinyaller yakın küme olarak birlikte okunur; eşit skorlar eş liderdir."
      : "Active signals within five points of the top score form a near cluster; equal scores are co-leading.",
    differenceRule: lang === "tr"
      ? "Mutlak fark 0-15 doğal hale yakın, 16-30 doğal halden uzak, 30 üzeri doğal halden çok uzak olarak yorumlanır."
      : "Absolute differences of 0-15 are close, 16-30 far and over 30 very far from the natural state.",
    bands: SCORE_BANDS.map((band) => ({ ...band, label: band[lang], range: `${band.min}-${band.max}` }))
  };
}

function buildEvidenceNotes(lang) {
  if (lang === "en") {
    return [
      "Marston's 1928 work is the historical root of the four-response language; modern DISC assessments and labels were developed later and differ by provider.",
      "Wiley's Everything DiSC research supports reading people as blends and treating adjacent patterns as meaningful, while its psychometric evidence applies to that specific instrument rather than automatically to every DISC test.",
      "TTI materials provide a practitioner rationale for separate natural and adapted views. Someren Labs' score bands, five-point near cluster and ±15/30 difference rules are explicit house interpretation rules.",
      "Longitudinal developmental research supports continuity between early temperament and later personality but also shows change across life. The ages 0-7 'first essence' phrase is therefore presented as a Someren Labs metaphor, not a fixed-age scientific fact."
    ];
  }
  return [
    "Marston'ın 1928 tarihli çalışması dört tepki dilinin tarihsel köküdür; modern DISC ölçümleri ve bugünkü adlandırmalar daha sonra geliştirilmiş, sağlayıcıya göre farklılaşmıştır.",
    "Wiley Everything DiSC araştırmaları insanların tek tip değil karışım olarak okunmasını ve yakın örüntülerin anlamlılığını destekler; bu psikometrik kanıtlar ilgili ölçüm aracına aittir, her DISC testine otomatik taşınamaz.",
    "TTI kaynakları doğal ve uyarlanmış görünümlerin ayrı okunmasına uygulayıcı gerekçesi sağlar. Someren Labs'ın yoğunluk bantları, 5 puanlık yakın kümesi ve ±15/30 fark kuralları açıkça kuruma özgü yorumlama kurallarıdır.",
    "Boylamsal gelişim araştırmaları erken mizaç ile sonraki kişilik arasında süreklilik bulurken yaşam boyunca değişimi de gösterir. Bu nedenle 0-7 yaş 'ilk öz' ifadesi sabit yaş gerçeği değil, Someren Labs gelişim metaforu olarak sunulur."
  ];
}

function normalizeScores(scores = {}) {
  return Object.fromEntries(DISC_LABELS.map((key) => [key, clampScore(scores[key])]));
}

function clampScore(value) {
  const number = Number(value ?? 0);
  if (!Number.isFinite(number)) return 0;
  return Math.max(0, Math.min(100, Math.round(number)));
}

function sortScores(scores) {
  return DISC_LABELS
    .map((key, order) => ({ key, value: scores[key], order }))
    .sort((a, b) => b.value - a.value || a.order - b.order);
}

function joinKeys(keys, lang) {
  if (!keys.length) return "";
  if (keys.length === 1) return keys[0];
  const conjunction = lang === "tr" ? " ve " : " and ";
  return `${keys.slice(0, -1).join(", ")}${conjunction}${keys[keys.length - 1]}`;
}

function formatDelta(delta) {
  return `${delta > 0 ? "+" : ""}${delta}`;
}

// ─────────────────────────────────────────────────────────────────────────────
// LİTERATÜR KATMANI ANLATILARI (2026-08-17)
// Kaynak: discLiterature.js — Marston eksenleri ve 15 klasik DISC örüntüsü.
// Bu üç bölüm, raporu harf sıralamasının ötesine taşıyan asıl kişiselleştirme
// kaynağıdır: örüntü hem uyarlanmış hem doğal grafik için ayrı hesaplanır ve
// ikisinin farkı ayrıca yorumlanır.
// ─────────────────────────────────────────────────────────────────────────────

function noktasiz(metin) {
  return String(metin || "").trim().replace(/[.]+$/, "");
}

function buildPatternReading(profile, lang) {
  const u = profile.oruntu;
  const d = profile.oruntuDogal;
  const bloklar = [];

  // Yüzde biçimi dile bağlıdır: TR "%98 yakınlık" · EN "98% match".
  // Daha önce başlık iki dilde de Türkçe kuruluyordu ("Result-Oriented · %98 yakınlık").
  const yakinlikEtiketi = (o) =>
    o.duz ? o.ad : (lang === "tr" ? `${o.ad} · %${o.yakinlik} yakınlık` : `${o.ad} · ${o.yakinlik}% match`);

  bloklar.push({
    key: "adapted",
    title: lang === "tr" ? "Uyarlanmış örüntü" : "Adapted pattern",
    heading: yakinlikEtiketi(u),
    body: u.duz
      ? u.ozet
      : (lang === "tr"
          ? `${u.ozet} Bu okuma, kişinin mevcut iş ortamındaki görünür davranış biçimine dayanır. Örüntünün taşıyıcı gücü: ${u.guc} Dikkat gerektiren tarafı: ${u.gerilim}`
          : `${u.ozet} This reading is based on visible behaviour in the current work context. Its carrying strength: ${u.guc} Its tension: ${u.gerilim}`)
  });

  bloklar.push({
    key: "natural",
    title: lang === "tr" ? "Doğal örüntü" : "Natural pattern",
    heading: yakinlikEtiketi(d),
    body: d.duz
      ? d.ozet
      : (lang === "tr"
          ? `Doğal grafikte örüntü ${d.ad} biçimine yaklaşır: ${d.ozet}`
          : `In the natural graph the pattern approaches ${d.ad}: ${d.ozet}`)
  });

  // İki grafiğin örüntüsü aynı mı? Raporun en ayırt edici cümlesi burada kurulur.
  const ayni = u.key === d.key;
  bloklar.push({
    key: "shift",
    title: lang === "tr" ? "İki örüntü arasındaki ilişki" : "Relationship between the two patterns",
    heading: ayni
      ? (lang === "tr" ? "Aynı örüntü" : "Same pattern")
      : (lang === "tr" ? `${d.ad} → ${u.ad}` : `${d.ad} → ${u.ad}`),
    body: ayni
      ? (lang === "tr"
          ? `Doğal ve uyarlanmış grafik aynı örüntüye oturuyor. Bu, kişinin bugün sergilediği davranış biçiminin temel eğilimiyle uyumlu çalıştığını düşündürür; davranış büyük ölçüde "taşınan" değil "olunan" bir şeydir. Böyle profillerde gelişim konuşması, örüntüyü değiştirmek yerine örüntünün gerilim tarafını yönetmeye odaklanır: ${u.gerilim}`
          : `Both graphs land on the same pattern, suggesting current behaviour runs in line with the underlying tendency. Development conversations here focus on managing the pattern's tension rather than changing the pattern: ${u.gerilim}`)
      : (lang === "tr"
          ? `Doğal grafikte ${d.ad}, uyarlanmış grafikte ${u.ad} örüntüsü öne çıkıyor. Bu kayma, mevcut bağlamın kişiden farklı bir davranış bileşimi istediğini gösterir. Doğru soru "hangisi gerçek" değil, "bu kayma ne kadar süredir devam ediyor ve neye mal oluyor" sorusudur. Doğal örüntünün taşıyıcı gücü şuydu: ${noktasiz(d.guc)}. Uyarlanmış örüntü ise şu yönde çalışıyor: ${noktasiz(u.guc)}.`
          : `The natural graph leans toward ${d.ad} while the adapted graph leans toward ${u.ad}. The useful question is not which one is real, but how long the shift has been running and what it costs.`)
  });

  return bloklar;
}

function buildAxisReading(profile, lang) {
  const e = profile.eksen;
  const ed = profile.eksenDogal;
  const odakKaydi = e.odak !== ed.odak;
  const temperKaydi = e.temper !== ed.temper;

  const satirlar = [
    lang === "tr"
      ? `Marston'ın iki ekseninde uyarlanmış profil ${e.odak.toLocaleLowerCase("tr-TR")} ve ${e.temper.toLocaleLowerCase("tr-TR")} bölgeye düşüyor. Görev tarafı (D+C) ${e.gorevPuani}, insan tarafı (I+S) ${e.insanPuani}; dışa dönük taraf (D+I) ${e.disaPuani}, içe dönük taraf (S+C) ${e.icePuani} puandır.`
      : `On Marston's two axes the adapted profile sits in the ${e.odak.toLowerCase()} and ${e.temper.toLowerCase()} region. Task side (D+C) ${e.gorevPuani}, people side (I+S) ${e.insanPuani}; outward (D+I) ${e.disaPuani}, reserved (S+C) ${e.icePuani}.`
  ];

  if (odakKaydi || temperKaydi) {
    satirlar.push(lang === "tr"
      ? `Doğal profil ise ${ed.odak.toLocaleLowerCase("tr-TR")} ve ${ed.temper.toLocaleLowerCase("tr-TR")} bölgededir. ${odakKaydi ? "Görev-insan ekseninde" : "Eylem-temkin ekseninde"} bir kayma vardır; bu, bağlamın kişiden ekseni değiştirmesini istediği anlamına gelebilir ve en çok enerji tüketen uyarlama türüdür.`
      : `The natural profile sits in the ${ed.odak.toLowerCase()} and ${ed.temper.toLowerCase()} region. This axis shift is usually the most energy-consuming form of adaptation.`);
  } else {
    satirlar.push(lang === "tr"
      ? "Doğal profil de aynı bölgededir; kişi eksen değiştirmeden, yalnız kanal yoğunluğunu ayarlayarak uyum sağlıyor görünmektedir."
      : "The natural profile sits in the same region; adaptation appears to happen through channel intensity rather than an axis change.");
  }

  satirlar.push(lang === "tr"
    ? "Eksenler bir etiket değil, okuma aracıdır: aynı çeyrekte yer alan iki kişi, kanal yoğunlukları farklı olduğu için çok farklı davranabilir."
    : "The axes are a reading tool, not a label: two people in the same quadrant can behave very differently depending on channel intensity.");

  return satirlar.join(" ");
}

function buildAdaptationEnergy(profile, lang) {
  const en = profile.enerji;
  const parcalar = [en.metin];

  if (en.yukselen.length) {
    parcalar.push(lang === "tr"
      ? `Bugün doğal hâlinden daha görünür kullanılan kanallar: ${joinKeys(en.yukselen, lang)}.`
      : `Channels used more visibly than naturally: ${joinKeys(en.yukselen, lang)}.`);
  }
  if (en.alcalan.length) {
    parcalar.push(lang === "tr"
      ? `Daha ölçülü, bastırılmış veya bilinçli olarak geri çekilmiş kanallar: ${joinKeys(en.alcalan, lang)}.`
      : `Channels held back or deliberately moderated: ${joinKeys(en.alcalan, lang)}.`);
  }
  if (!en.yukselen.length && !en.alcalan.length) {
    parcalar.push(lang === "tr"
      ? "Hiçbir kanalda 10 puanı aşan bir hareket yok; profil iki grafikte de aynı biçimi koruyor."
      : "No channel moves by more than 10 points; the profile keeps the same shape in both graphs.");
  }

  parcalar.push(lang === "tr"
    ? `Toplam hareket ${en.toplam} puandır. Bu sayı bir başarı ölçütü değildir: düşük olması "uyumsuz", yüksek olması "esnek" anlamına gelmez. Yalnızca, mevcut rolün kişiden ne kadar davranış ayarı istediğini gösterir ve bu ayarın sürdürülebilirliği görüşmede konuşulmalıdır.`
    : `Total movement is ${en.toplam} points. This is not a performance measure: low does not mean inflexible and high does not mean adaptable. It only shows how much behavioural adjustment the current role asks for.`);

  return parcalar.join(" ");
}
